import { useEffect, useState, useCallback } from "react";
import {
  Container,
  Table,
  Button,
  Card,
  Row,
  Col,
  Badge,
  Alert,
  Spinner,
  Modal,
  Form,
} from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import {
  getTicketsByOrgId,
  organizationEmailApi,
  emailProcessingApi,
  createTicket,
  updateTicket,
  attachmentApi,
  getTicketsByAssignedResource,
  addTicketLog,
  closeTicket,
  getTicketsByFromMail,
  addTicketWorkLog,
  getTicketSla,
  getTicketSlaLogs,
  getTicketDropdownData,
  resolveNames,
} from "../Api/TicketApiOrg";
import {
  fetchCusVenCpById,
  fetchCusVenCpByOrgId,
} from "../Api/CusVenCpMasterApi";

import TicketCreateModal from "./TicketCreateModal";

import "./Ticket.css";

import { Link } from "react-router-dom";

import { useAuth } from "../Context/AuthContext";
import { fetchProjectsByOrg } from "../Api/ViewProjects";
import Select from "react-select";
import { fetchProjectDetails } from "../Api/ViewProjects";
import { getPartnersByProject } from "../Api/PartnerMaster";
import { fetchCusVenCpByCusVenType } from "../Api/CusVenCpMasterApi";
import { getTeamById } from "../Api/TeamMaster";
import { getUserById } from "../Api/Auth";
import { getResourceByMavUserId } from "../Api/ResourceList";
import { fetchResourceById } from "../Api/ResourceMaster";
import { getResourcesByOrgId } from "../Api/ResourceList";
import { getAllTicketClosureTypes } from "../Api/TicketApiOrg";
import { getAllTicketLoggedTypes } from "../Api/TicketApiOrg";
import { getTicketLogsByTicketId } from "../Api/TicketApiOrg";
import { getTasksByTicketId } from "../Api/TicketApiOrg";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import TicketEditModal from "./TicketEditModal";

const ViewTickets = () => {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const orgId = userDetails?.organisationId;

  const loggedInEmail = userDetails?.email?.toLowerCase();

  const [showCreateModal, setShowCreateModal] = useState(false);

  const [connectionStatus, setConnectionStatus] = useState(null);
  const [organizationEmails, setOrganizationEmails] = useState([]);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showTicketInfoModal, setShowTicketInfoModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [newEmail, setNewEmail] = useState({ emailType: "", emailId: "" });
  const [testResults, setTestResults] = useState(null);
  const [projectPartnerMap, setProjectPartnerMap] = useState({});
  const [assigneeOptionsByProject, setAssigneeOptionsByProject] = useState({});
  const [userCache, setUserCache] = useState({});
  const [ticketAssignees, setTicketAssignees] = useState([]);
  const [assignedToOptions, setAssignedToOptions] = useState([]);
  const [showClosureModal, setShowClosureModal] = useState(false);

  const [closureTypes, setClosureTypes] = useState([]);
  const [loadingClosureTypes, setLoadingClosureTypes] = useState(false);

  const [ticketLoggedTypes, setTicketLoggedTypes] = useState([]);
  const [loadingTicketReasons, setLoadingTicketReasons] = useState(false);

  const [ticketLogs, setTicketLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(false);

  const [ticketTasks, setTicketTasks] = useState([]);
  const [loadingTasks, setLoadingTasks] = useState(false);

  const [ticketSla, setTicketSla] = useState(null);
  const [slaLogs, setSlaLogs] = useState([]);

  const [globalSearch, setGlobalSearch] = useState("");

  const [cusVenCpCache, setCusVenCpCache] = useState({});

  const ITEMS_PER_PAGE = 100;

  const [currentPage, setCurrentPage] = useState(1);

  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const [filterUserOptions, setFilterUserOptions] = useState([]);

  const [cusVenOptions, setCusVenOptions] = useState([]);

  const [showOnlyActive, setShowOnlyActive] = useState(true);

  // Add state for resolved names
  const [resolvedNames, setResolvedNames] = useState({
    types: {},
    reasons: {},
    categories: {},
  });

  // Add state for dropdown data
  const [dropdownData, setDropdownData] = useState([]);

  const STATUS_SUBSTATUS_MAP = {
    Open: ["New", "Awaiting Assignment", "Assigned", "Pending Triage"],
    "In Progress": [
      "Investigation Ongoing",
      "Work in Progress",
      "Pending Customer Input",
      "Blocked",
      "Reopened",
    ],
    Resolved: ["Fixed", "Workaround Provided", "Duplicate", "Cannot Reproduce"],
    Closed: ["Successfully Closed", "Auto Closed", "Rejected"],
  };

  const [filters, setFilters] = useState({
    status: [],
    ticketType: [],
    priority: [],
    submittedBy: [],
    assignedTo: [],
    fromMail: "",
    projectAssigned: [],
  });

  const [showWorkLogModal, setShowWorkLogModal] = useState(false);

  const [workLogForm, setWorkLogForm] = useState({
    workedBy: "",
    effortValue: "",
    effortUnit: "HOURS",
    remarks: "",
  });

  const resetTicketScopedState = () => {
    setTicketAssignees([]);
    setUpdateForm({
      ticketName: "",
      description: "",
      status: "",
      priority: "",
      assignedTo: [],
      createdBy: "",
      submittedBy: "",
      category: "",
      dueDate: "",
      referenceTo: "",
      projectAssigned: "",
      ticketType: "",
      ticketReason: "",
    });
  };

  const [closureForm, setClosureForm] = useState({
    closureTypeCode: "",
    closureRemarks: "",
    efforts: [
      {
        workedBy: "",
        effortValue: "",
        effortUnit: "HOURS",
      },
    ],
  });

  const addEffortRow = () => {
    setClosureForm((prev) => ({
      ...prev,
      efforts: [
        ...prev.efforts,
        { workedBy: "", effortValue: "", effortUnit: "HOURS" },
      ],
    }));
  };

  const removeEffortRow = (index) => {
    setClosureForm((prev) => ({
      ...prev,
      efforts: prev.efforts.filter((_, i) => i !== index),
    }));
  };

  const updateEffortRow = (index, field, value) => {
    const updated = [...closureForm.efforts];
    updated[index][field] = value;

    setClosureForm((prev) => ({
      ...prev,
      efforts: updated,
    }));
  };

  const [updateForm, setUpdateForm] = useState({
    ticketName: "",
    description: "",
    status: "",
    priority: "",
    assignedTo: [],
    createdBy: "",
    submittedBy: "",
    category: "",
    dueDate: "",
    referenceTo: "",
    projectAssigned: "",
    ticketType: "",
    ticketReason: "",
    subStatus: "",
  });
  const { user } = useAuth();
  const [attachments, setAttachments] = useState({});
  const [loadingAttachments, setLoadingAttachments] = useState({});
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
  const [selectedTicketAttachments, setSelectedTicketAttachments] = useState(
    [],
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [statusFilter, setStatusFilter] = useState([]);
  const statusOptions = [
    { value: "Open", label: "Open" },
    { value: "In Progress", label: "In Progress" },
    { value: "Resolved", label: "Resolved" },
    { value: "Closed", label: "Closed" },
  ];

  const EXCLUDED_PROJECT_STATUSES = ["S009", "S010"];

  const normalizeToOptions = (items, mapper, sourceLabel) => {
    return items.map((item) => ({
      value: mapper.value(item),
      label: `${mapper.label(item)} (${sourceLabel})`,
    }));
  };

  // Function to resolve all names for tickets
  // Function to resolve all names for tickets
  const resolveAllTicketNames = useCallback(async (ticketsList) => {
    if (!ticketsList || ticketsList.length === 0) return;

    // Helper function to check if a string is a valid GUID
    const isValidGuid = (guid) => {
      if (!guid || typeof guid !== "string") return false;
      const guidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return guidRegex.test(guid);
    };

    // Collect unique IDs - only include valid GUIDs for types and categories
    const uniqueTypeGuids = new Set();
    const uniqueReasonCodes = new Set();
    const uniqueCategoryGuids = new Set();

    ticketsList.forEach((ticket) => {
      // Only add if it's a valid GUID
      if (ticket.ticketType && isValidGuid(ticket.ticketType)) {
        uniqueTypeGuids.add(ticket.ticketType);
      }
      // Reason codes are strings like TLT001 - always add
      if (ticket.ticketReason) {
        uniqueReasonCodes.add(ticket.ticketReason);
      }
      // Only add category if it's a valid GUID
      if (ticket.category && isValidGuid(ticket.category)) {
        uniqueCategoryGuids.add(ticket.category);
      }
    });

    console.log("🟢 Resolving names for:", {
      types: Array.from(uniqueTypeGuids),
      reasons: Array.from(uniqueReasonCodes),
      categories: Array.from(uniqueCategoryGuids),
    });

    // Only call API if we have valid IDs to resolve
    if (
      uniqueTypeGuids.size === 0 &&
      uniqueReasonCodes.size === 0 &&
      uniqueCategoryGuids.size === 0
    ) {
      console.log("No valid IDs to resolve");
      return;
    }

    try {
      const resolved = await resolveNames(
        Array.from(uniqueTypeGuids),
        Array.from(uniqueReasonCodes),
        Array.from(uniqueCategoryGuids),
      );

      console.log("🟢 Resolved names:", resolved);

      setResolvedNames({
        types: resolved.typeNames || {},
        reasons: resolved.reasonNames || {},
        categories: resolved.categoryNames || {},
      });
    } catch (error) {
      console.error("Failed to resolve names:", error);
    }
  }, []);

  // Load dropdown data
  const loadDropdownData = async () => {
    try {
      if (!orgId) return;
      const data = await getTicketDropdownData(orgId);
      setDropdownData(data);
    } catch (error) {
      console.error("Failed to load dropdown data:", error);
    }
  };

  const fetchTicketLoggedTypes = async () => {
    try {
      setLoadingTicketReasons(true);
      const res = await getAllTicketLoggedTypes();
      const activeTypes = (res || []).filter((x) => x.active === true);
      setTicketLoggedTypes(activeTypes);
    } catch (error) {
      console.error("❌ Failed to load ticket logged types", error);
      toast.error("Failed to load ticket reasons");
    } finally {
      setLoadingTicketReasons(false);
    }
  };

  const fetchCusVenCpIfNeeded = async (cpId) => {
    if (!cpId || !cpId.startsWith("CVCP")) return null;
    if (cusVenCpCache[cpId]) {
      return cusVenCpCache[cpId];
    }
    try {
      const cp = await fetchCusVenCpById(cpId);
      if (cp?.contactPerName) {
        setCusVenCpCache((prev) => ({
          ...prev,
          [cpId]: cp.contactPerName,
        }));
        return cp.contactPerName;
      }
    } catch (err) {
      console.error("❌ Failed to fetch CP:", cpId, err);
    }
    return cpId;
  };

  useEffect(() => {
    fetchCusVenContactPersonsByOrg();
  }, [orgId]);

  useEffect(() => {
    if (orgId) {
      loadDropdownData();
    }
  }, [orgId]);

  const fetchCusVenContactPersonsByOrg = async () => {
    try {
      if (!orgId) return;
      const cpData = await fetchCusVenCpByOrgId(orgId);
      if (!Array.isArray(cpData)) return;
      const formatted = cpData.map((cp) => ({
        value: cp.cusVenId,
        label: `${cp.contactPerName} (Contact Person)`,
      }));
      setCusVenOptions(formatted);
    } catch (error) {
      console.error("❌ Failed to fetch CusVen CP by Org", error);
    }
  };

  const resolveAssigneeNameAsync = async (ids) => {
    if (!ids) return "N/A";
    const idArray =
      typeof ids === "string" ? ids.split(",").map((i) => i.trim()) : ids;
    const names = await Promise.all(
      idArray.map(async (id) => {
        if (id.startsWith("CVCP")) {
          return await fetchCusVenCpIfNeeded(id);
        }
        const match = assignedToOptions.find((opt) => opt.value === id);
        return match ? match.label.replace(/\s*\(.*\)$/, "") : id;
      }),
    );
    return names.join(", ");
  };

  const fetchClosureTypes = async () => {
    try {
      setLoadingClosureTypes(true);
      const res = await getAllTicketClosureTypes();
      const activeTypes = (res?.data || []).filter((x) => x.active === true);
      setClosureTypes(activeTypes);
    } catch (error) {
      console.error("❌ Failed to fetch closure types", error);
      toast.error("Failed to load closure types");
    } finally {
      setLoadingClosureTypes(false);
    }
  };

  const projectOptions = projects
    .filter(
      (project) => !EXCLUDED_PROJECT_STATUSES.includes(project.projectStatus),
    )
    .sort((a, b) =>
      (a.prTitle || "").localeCompare(b.prTitle || "", undefined, {
        sensitivity: "base",
      }),
    )
    .map((project) => ({
      value: project.projectId,
      label: `${project.prTitle} (${project.projectId})`,
    }));

  const hasAdminTicketRole = () => {
    return (
      Array.isArray(userDetails?.roles) &&
      userDetails.roles.includes("Admin Ticket")
    );
  };

  const resolveNameWithId = (ids) => {
    if (!ids) return "";
    const idArray =
      typeof ids === "string" ? ids.split(",").map((i) => i.trim()) : ids;
    return idArray
      .map((id) => {
        if (id.startsWith("CVCP")) {
          const name = cusVenCpCache[id];
          return name ? `${name} (${id})` : id;
        }
        const match = assignedToOptions.find((opt) => opt.value === id);
        if (match) {
          const cleanName = match.label.replace(/\s*\(.*\)$/, "");
          return `${cleanName} (${id})`;
        }
        return id;
      })
      .join(", ");
  };

  const resolveProjectWithId = (projectAssigned) => {
    if (!projectAssigned) return "";
    const projectIds = projectAssigned.split(",").map((id) => id.trim());
    return projectIds
      .map((projectId) => {
        const project = projects.find(
          (p) => p.projectId === projectId || p.prozmaPrId === projectId,
        );
        return project ? `${project.prTitle} (${projectId})` : projectId;
      })
      .join(", ");
  };

  // Updated resolve functions to use resolved names
  // Updated resolve functions to handle invalid values
  const resolveTicketType = (typeGuid) => {
    if (!typeGuid) return "N/A";
    // Check if it's a valid GUID
    const isValidGuid =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        typeGuid,
      );

    if (isValidGuid) {
      const resolvedName = resolvedNames.types[typeGuid];
      if (resolvedName) {
        return resolvedName;
      }
      return typeGuid.substring(0, 8);
    }
    // If not a GUID, return as is (it might be a legacy string value)
    return typeGuid;
  };

  const resolveTicketReason = (code) => {
    if (!code) return "N/A";
    const resolvedName = resolvedNames.reasons[code];
    if (resolvedName) {
      return resolvedName;
    }
    return code;
  };

  const resolveCategoryName = (categoryGuid) => {
    if (!categoryGuid) return "N/A";
    // Check if it's a valid GUID
    const isValidGuid =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        categoryGuid,
      );

    if (isValidGuid) {
      const resolvedName = resolvedNames.categories[categoryGuid];
      if (resolvedName) {
        return resolvedName;
      }
      return categoryGuid.substring(0, 8);
    }
    // If not a GUID, return as is (it might be a legacy string value)
    return categoryGuid;
  };

  const handleAddWorkLog = async () => {
    try {
      if (!workLogForm.workedBy || !workLogForm.effortValue) {
        toast.error("Please fill all required fields");
        return;
      }
      const now = moment();
      const payload = {
        ticketId: selectedTicket.ticketId,
        orgId: String(orgId),
        createdBy: String(userDetails.userId),
        changedBy: String(userDetails.userId),
        changedDate: now.format("YYYY-MM-DD"),
        changedTime: now.format("HH:mm:ss"),
        workedBy: workLogForm.workedBy,
        effortValue: Number(workLogForm.effortValue),
        effortUnit: workLogForm.effortUnit,
        closureRemarks: workLogForm.remarks,
      };
      await addTicketWorkLog(payload);
      toast.success("Work log added successfully!");
      setShowWorkLogModal(false);
      setWorkLogForm({
        workedBy: "",
        effortValue: "",
        effortUnit: "HOURS",
        remarks: "",
      });
      if (selectedTicket) {
        const logs = await getTicketLogsByTicketId(selectedTicket.ticketId);
        setTicketLogs(logs || []);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to add work log");
    }
  };

  const handleConfirmClosure = async () => {
    try {
      if (!closureForm.closureTypeCode) {
        toast.error("Closure type is required");
        return;
      }
      if (
        closureForm.efforts.some(
          (e) => !e.workedBy || !e.effortValue || e.effortValue <= 0,
        )
      ) {
        toast.error("Please fill all effort details");
        return;
      }
      const payload = {
        ticketId: selectedTicket.ticketId,
        orgId,
        closureTypeCode: closureForm.closureTypeCode,
        closureRemarks: closureForm.closureRemarks,
        createdBy: String(userDetails.userId),
        efforts: closureForm.efforts.map((e) => ({
          workedBy: e.workedBy,
          effortValue: Number(e.effortValue),
          effortUnit: e.effortUnit,
        })),
      };
      console.log("🟢 Closing ticket with payload:", payload);
      await closeTicket(payload);
      toast.success("Ticket closed successfully!");
      setShowClosureModal(false);
      setShowUpdateModal(false);
      fetchTickets();
    } catch (error) {
      console.error(error);
      toast.error("Failed to close ticket");
    }
  };

  const handleExportToExcel = () => {
    if (!filteredTickets.length) {
      toast.info("No tickets to export");
      return;
    }
    const formattedData = filteredTickets.map((ticket, index) => ({
      "S.No": index + 1,
      "Ticket ID": ticket.ticketId,
      "Ticket Name": ticket.ticketName,
      "Ticket Time": ticket.ticketTime
        ? moment(ticket.ticketTime).format("YYYY-MM-DD HH:mm")
        : "",
      Status: ticket.status,
      Priority: ticket.priority,
      "Ticket Type": resolveTicketType(ticket.ticketType),
      "Submitted By": resolveNameWithId(ticket.submittedBy),
      "Assigned To": resolveNameWithId(ticket.assignedTo),
      "From Mail": ticket.fromMail,
      Category: resolveCategoryName(ticket.category),
      "Project Assigned": resolveProjectWithId(ticket.projectAssigned),
      "Ticket Reason": resolveTicketReason(ticket.ticketReason),
      "Due Date": ticket.dueDate
        ? moment(ticket.dueDate).format("YYYY-MM-DD")
        : "",
    }));
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tickets");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, `Tickets_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
  };

  const buildAssignedToOptions = async () => {
    try {
      if (!userDetails?.userId || !orgId) return;
      const options = [];
      const seen = new Set();
      const resResponse = await getResourceByMavUserId(userDetails.userId);
      const selfResource = resResponse?.resource;
      if (!selfResource?.resourceId) {
        console.warn("❌ Resource not found for logged-in user");
        return;
      }
      const addOption = (resource, suffix = "") => {
        if (!resource?.resourceId || seen.has(resource.resourceId)) return;
        options.push({
          value: resource.resourceId,
          label: suffix ? `${resource.name} (${suffix})` : resource.name,
        });
        seen.add(resource.resourceId);
      };
      addOption(selfResource, "You");
      if (selfResource.lineManager) {
        const lm = await fetchResourceById(selfResource.lineManager);
        addOption(lm, "Line Manager");
      }
      if (selfResource.dotLineManager) {
        const dlm = await fetchResourceById(selfResource.dotLineManager);
        addOption(dlm, "Dot Line Manager");
      }
      const orgResResponse = await getResourcesByOrgId(orgId);
      const orgResources = Array.isArray(orgResResponse)
        ? orgResResponse
        : orgResResponse?.resources || [];
      orgResources.forEach((res) => {
        addOption(res);
      });
      const pinned = options.filter((o) => o.label.includes("(You)"));
      const rest = options
        .filter((o) => !o.label.includes("(You)"))
        .sort((a, b) => a.label.localeCompare(b.label));
      const finalOptions = [...pinned, ...rest];
      console.log("✅ Final AssignedTo Options:", finalOptions);
      setAssignedToOptions(finalOptions);
    } catch (error) {
      console.error("❌ Failed to build Assigned To options", error);
    }
  };

  const getSelectedProjectOptions = () => {
    if (!updateForm.projectAssigned) return [];
    const selectedIds = updateForm.projectAssigned.split(",");
    return projectOptions.filter((opt) => selectedIds.includes(opt.value));
  };

  const handleProjectSelectChange = (selectedOptions) => {
    const ids = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
    setUpdateForm({
      ...updateForm,
      projectAssigned: ids.join(","),
    });
  };

  const fetchTickets = async () => {
    try {
      setLoading(true);
      let ticketsData = [];

      if (hasAdminTicketRole()) {
        ticketsData = await getTicketsByOrgId(orgId);
        console.log(ticketsData);
      } else {
        const combinedMap = new Map();
        try {
          const res = await getResourceByMavUserId(userDetails.userId);
          const resourceId = res?.resource?.resourceId;
          if (resourceId) {
            const assignedTickets =
              await getTicketsByAssignedResource(resourceId);
            (assignedTickets || []).forEach((t) =>
              combinedMap.set(t.ticketId, t),
            );
          }
        } catch (e) {
          console.warn("No assigned tickets");
        }
        if (loggedInEmail) {
          try {
            const allTickets = await getTicketsByOrgId(orgId);
            (allTickets || []).forEach((t) => {
              const emails = [
                ...(t.fromMails || []),
                ...(t.fromMail ? [t.fromMail] : []),
              ]
                .map((e) => e?.toLowerCase().trim())
                .filter(Boolean);
              if (emails.includes(loggedInEmail)) {
                combinedMap.set(t.ticketId, t);
              }
            });
          } catch (e) {
            console.warn("No FromMail tickets");
          }
        }
        ticketsData = [...combinedMap.values()];
      }

      setTickets(ticketsData || []);
      // Resolve names after fetching tickets
      if (ticketsData && ticketsData.length > 0) {
        await resolveAllTicketNames(ticketsData);
      }
    } catch (err) {
      console.error("❌ Failed to load tickets", err);
      toast.error("Failed to load tickets");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrganizationProjects = async () => {
    try {
      if (!user?.organisationId) return;
      const projectsData = await fetchProjectsByOrg(user.organisationId);
      setProjects(projectsData);
      console.log("✅ Fetched organization projects:", projectsData);
    } catch (error) {
      console.error("Error fetching organization projects:", error);
      toast.error("Failed to load projects");
    }
  };

  const getProjectNameById = (projectId) => {
    if (!projectId) return "N/A";
    const project = projects.find(
      (proj) => proj.projectId === projectId || proj.prozmaPrId === projectId,
    );
    return project ? project.prTitle : projectId;
  };

  const getProjectDetailsById = (projectId) => {
    if (!projectId) return null;
    return projects.find(
      (proj) => proj.projectId === projectId || proj.prozmaPrId === projectId,
    );
  };

  const fetchProjectAndPartners = async (projectId) => {
    try {
      console.log("🟢 fetchProjectAndPartners START for:", projectId);
      if (projectPartnerMap[projectId]) {
        console.log("⚠️ Project already cached, skipping:", projectId);
        return;
      }
      const localOptions = [];
      const projectDetails = await fetchProjectDetails(projectId);
      console.log("📌 Project Details:", projectDetails);
      console.log("👥 teamAssigned (project):", projectDetails?.teamAssigned);
      if (projectDetails?.prClient) {
        const clientCPs = await fetchCusVenContactPersons(
          projectDetails.prClient,
          "Project Client",
        );
        if (Array.isArray(clientCPs)) {
          localOptions.push(
            ...normalizeToOptions(
              clientCPs,
              {
                value: (cp) => cp.cusVenId,
                label: (cp) => cp.contactPerName,
              },
              "Client",
            ),
          );
        }
      }
      let partners = [];
      try {
        partners = await getPartnersByProject(projectId);
        console.log("🤝 Partners:", partners);
      } catch (error) {
        if (error?.response?.status === 404) {
          console.warn("⚠️ No partners for project:", projectId);
          partners = [];
        } else {
          throw error;
        }
      }
      if (Array.isArray(partners)) {
        for (const partner of partners) {
          if (partner?.partnerName) {
            const partnerCPs = await fetchCusVenContactPersons(
              partner.partnerName,
              "Partner",
            );
            if (Array.isArray(partnerCPs)) {
              localOptions.push(
                ...normalizeToOptions(
                  partnerCPs,
                  {
                    value: (cp) => cp.cusVenId,
                    label: (cp) => cp.contactPerName,
                  },
                  "Partner",
                ),
              );
            }
          }
        }
      }
      if (projectDetails?.teamAssigned) {
        const teamData = await getTeamById(projectDetails.teamAssigned);
        console.log("✅ Team API Response:", teamData);
        console.log("👤 Team Members IDs:", teamData?.teamMembers);
        if (Array.isArray(teamData?.teamMembers)) {
          for (const memberId of teamData.teamMembers) {
            const user = await fetchUserIfNeeded(memberId);
            if (!user) continue;
            const res = await getResourceByMavUserId(user.userId);
            const resource = res?.resource;
            if (!resource?.resourceId) continue;
            localOptions.push({
              value: resource.resourceId,
              label: `${resource.name} (Team)`,
            });
          }
        }
      }
      console.log(
        "🟢 FINAL assignee options for project",
        projectId,
        localOptions,
      );
      setAssigneeOptionsByProject((prev) => {
        const existing = prev[projectId] || [];
        const map = new Map();
        existing.forEach((opt) => map.set(opt.value, opt));
        localOptions.forEach((opt) => map.set(opt.value, opt));
        return {
          ...prev,
          [projectId]: Array.from(map.values()),
        };
      });
      setProjectPartnerMap((prev) => ({
        ...prev,
        [projectId]: {
          projectDetails,
          partners,
        },
      }));
      console.log("🟢 Building assignee options for project:", projectId);
      console.log("Final assignee options:", localOptions);
    } catch (error) {
      console.error("❌ Error fetching project/partners/team:", error);
    }
  };

  const fetchUserIfNeeded = async (userId) => {
    if (!userId) return null;
    if (userCache[userId]) {
      return userCache[userId];
    }
    try {
      console.log("🔹 Fetching user by ID:", userId);
      const response = await getUserById(userId);
      const user = response?.user;
      if (!user) return null;
      setUserCache((prev) => ({
        ...prev,
        [userId]: user,
      }));
      return user;
    } catch (error) {
      console.error(`❌ Failed to fetch user ${userId}`, error);
      return null;
    }
  };

  const getAssigneesForTicket = (ticket) => {
    if (!ticket?.projectAssigned) return [];
    const projectIds = ticket.projectAssigned.split(",").map((id) => id.trim());
    const map = new Map();
    projectIds.forEach((pid) => {
      const assignees = assigneeOptionsByProject?.[pid] || [];
      assignees.forEach((opt) => map.set(opt.value, opt));
    });
    return Array.from(map.values());
  };

  const fetchOrganizationEmails = async () => {
    try {
      const emails = await organizationEmailApi.getEmailsByOrgId(
        user.organisationId,
      );
      setOrganizationEmails(emails);
    } catch (error) {
      console.error("Error fetching organization emails:", error);
    }
  };

  const fetchCusVenContactPersons = async (cusVenTypeId, label = "") => {
    try {
      if (!cusVenTypeId) return [];
      console.log(`🔹 Fetching CusVen CP for ${label}:`, cusVenTypeId);
      const cpData = await fetchCusVenCpByCusVenType(cusVenTypeId);
      console.log(`✅ CusVen Contact Persons (${label}):`, cpData);
      return Array.isArray(cpData) ? cpData : [];
    } catch (error) {
      if (error?.response?.status === 404) {
        console.warn(
          `⚠️ No contact persons found for ${label} (${cusVenTypeId})`,
        );
        return [];
      }
      console.error(
        `❌ Error fetching CusVen CP for ${label} (${cusVenTypeId})`,
        error,
      );
      return [];
    }
  };

  const resolveAssigneeName = (ids) => {
    if (!ids) return "N/A";
    const idArray =
      typeof ids === "string" ? ids.split(",").map((i) => i.trim()) : ids;
    return idArray
      .map((id) => {
        if (id.startsWith("CVCP")) {
          return cusVenCpCache[id] || id;
        }
        const match = assignedToOptions.find((opt) => opt.value === id);
        return match ? match.label.replace(/\s*\(.*\)$/, "") : id;
      })
      .join(", ");
  };

  const addFallbackAssignees = (projectId, localOptions) => {
    const fallback = [];
    if (userId) {
      fallback.push({
        value: String(userId),
        label: "You (Current User)",
      });
    }
    if (selectedTicket?.createdBy) {
      fallback.push({
        value: String(selectedTicket.createdBy),
        label: "Ticket Creator",
      });
    }
    const map = new Map();
    [...localOptions, ...fallback].forEach((opt) => map.set(opt.value, opt));
    return Array.from(map.values());
  };

  const handleResetFilters = () => {
    setGlobalSearch("");
    setShowOnlyActive(true);
    setCurrentPage(1);
    setFilters({
      status: [],
      ticketType: [],
      priority: [],
      submittedBy: [],
      assignedTo: [],
      fromMail: "",
      projectAssigned: [],
    });
    setSortConfig({ key: null, direction: "asc" });
  };

  const handleProcessEmails = async () => {
    try {
      setLoading(true);
      await emailProcessingApi.processOrganizationEmails(user.organisationId);
      toast.success("Email processing started successfully!");
      setTimeout(() => fetchTickets(), 2000);
    } catch (error) {
      console.error("Error processing emails:", error);
      toast.error("Failed to process emails");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [globalSearch, filters, showOnlyActive]);

  const handleAddEmail = async () => {
    try {
      if (!newEmail.emailType || !newEmail.emailId) {
        toast.error("Please fill in both email type and email address");
        return;
      }
      await organizationEmailApi.createOrganizationEmail({
        orgId: user.organisationId,
        emailType: newEmail.emailType,
        emailId: newEmail.emailId,
      });
      toast.success("Email added successfully!");
      setShowEmailModal(false);
      setNewEmail({ emailType: "", emailId: "" });
      fetchOrganizationEmails();
    } catch (error) {
      console.error("Error adding email:", error);
      toast.error("Failed to add email");
    }
  };

  const handleShowTicketInfo = async (ticket) => {
    setSelectedTicket(ticket);
    setShowTicketInfoModal(true);
    try {
      setLoadingLogs(true);
      setLoadingTasks(true);
      const logs = await getTicketLogsByTicketId(ticket.ticketId);
      setTicketLogs(logs || []);
      const tasks = await getTasksByTicketId(ticket.ticketId);
      setTicketTasks(tasks || []);
      const sla = await getTicketSla(ticket.ticketId);
      setTicketSla(sla);
      console.log(sla);
      const slalogs = await getTicketSlaLogs(ticket.ticketId);
      setSlaLogs(slalogs);
    } catch (error) {
      console.error("❌ Failed to load ticket info data", error);
      setTicketLogs([]);
      setTicketTasks([]);
    } finally {
      setLoadingLogs(false);
      setLoadingTasks(false);
    }
  };

  const formatActionType = (type) => type?.replace(/_/g, " ") || "N/A";

  const formatDateTime = (date, time) => {
    if (!date) return "N/A";
    return `${moment(date).format("MMM DD, YYYY")} ${time?.substring(0, 8) || ""}`;
  };

  useEffect(() => {
    if (!tickets.length) return;
    const fetchAllProjectsAndPartners = async () => {
      const projectIds = new Set();
      tickets.forEach((ticket) => {
        if (ticket.projectAssigned) {
          ticket.projectAssigned
            .split(",")
            .map((id) => id.trim())
            .forEach((id) => projectIds.add(id));
        }
      });
      for (const projectId of projectIds) {
        await fetchProjectAndPartners(projectId);
      }
    };
    fetchAllProjectsAndPartners();
  }, [tickets]);

  useEffect(() => {
    if (!selectedTicket || !selectedTicket.projectAssigned) return;
    const projectIds = selectedTicket.projectAssigned
      .split(",")
      .map((id) => id.trim());
    const map = new Map();
    projectIds.forEach((pid) => {
      const assignees = assigneeOptionsByProject[pid] || [];
      assignees.forEach((opt) => map.set(opt.value, opt));
    });
    setTicketAssignees(Array.from(map.values()));
  }, [selectedTicket, assigneeOptionsByProject]);

  useEffect(() => {
    if (!userDetails?.userId || !orgId) return;
    buildAssignedToOptions();
  }, [userDetails?.userId, orgId]);

  useEffect(() => {
    fetchClosureTypes();
  }, []);

  useEffect(() => {
    fetchTicketLoggedTypes();
  }, []);

  useEffect(() => {
    if (user?.organisationId) {
      fetchTickets();
      fetchOrganizationEmails();
      fetchOrganizationProjects();
    }
  }, [user]);

  const closureTypeOptions = closureTypes.map((ct) => ({
    value: ct.codefix,
    label: ct.description,
  }));

  const handleEditTicket = async (ticket) => {
    resetTicketScopedState();
    setSelectedTicket(null);
    if (ticket.projectAssigned) {
      const projectIds = ticket.projectAssigned
        .split(",")
        .map((id) => id.trim());
      for (const pid of projectIds) {
        if (!assigneeOptionsByProject[pid]) {
          await fetchProjectAndPartners(pid);
        }
      }
    }
    const projectIds = ticket.projectAssigned
      ? ticket.projectAssigned.split(",").map((id) => id.trim())
      : [];
    const map = new Map();
    projectIds.forEach((pid) => {
      (assigneeOptionsByProject[pid] || []).forEach((opt) =>
        map.set(opt.value, opt),
      );
    });
    const finalAssignees = Array.from(map.values());
    setTicketAssignees(finalAssignees);
    setUpdateForm({
      ticketName: ticket.ticketName || "",
      description: ticket.description || "",
      status: ticket.status || "Open",
      subStatus: ticket.subStatus || "",
      priority: ticket.priority || "Medium",
      assignedTo: ticket.assignedTo
        ? ticket.assignedTo.split(",").map((id) => id.trim())
        : [],
      createdBy: ticket.createdBy || "",
      submittedBy: ticket.submittedBy || "",
      category: ticket.category || "",
      referenceTo: ticket.referenceTo || "",
      dueDate: ticket.dueDate
        ? moment(ticket.dueDate).format("YYYY-MM-DD")
        : moment(ticket.ticketTime).add(10, "days").format("YYYY-MM-DD"),
      projectAssigned: ticket.projectAssigned || "",
      ticketType: ticket.ticketType || "Internal",
      ticketReason: ticket.ticketReason || "",
    });
    setSelectedTicket(ticket);
    setShowUpdateModal(true);
  };

  const ticketReasonOptions = ticketLoggedTypes.map((t) => ({
    value: t.code,
    label: t.descriptions,
  }));

  const fetchTeamDetails = async (teamId) => {
    try {
      if (!teamId) return;
      console.log("🔹 Fetching Team Details for:", teamId);
      const teamData = await getTeamById(teamId);
      console.log("✅ Team Details:", teamData);
      return teamData;
    } catch (error) {
      console.error(`❌ Error fetching team ${teamId}`, error);
    }
  };

  const handleProjectCheckboxChange = (projectId, isChecked) => {
    const currentProjects = updateForm.projectAssigned
      ? updateForm.projectAssigned.split(",").filter((id) => id !== "")
      : [];
    let updatedProjects;
    if (isChecked) {
      updatedProjects = [...currentProjects, projectId];
    } else {
      updatedProjects = currentProjects.filter((id) => id !== projectId);
    }
    setUpdateForm({
      ...updateForm,
      projectAssigned: updatedProjects.join(","),
    });
  };

  const isProjectSelected = (projectId) => {
    if (!updateForm.projectAssigned) return false;
    const selectedProjects = updateForm.projectAssigned.split(",");
    return selectedProjects.includes(projectId);
  };

  const handleUpdateTicket = async () => {
    try {
      if (!selectedTicket) return;
      if (!updateForm.dueDate || updateForm.dueDate.trim() === "") {
        toast.error("Due Date is required before updating the ticket.");
        return;
      }
      setLoading(true);
      const payload = {
        ticketId: selectedTicket.ticketId,
        ...updateForm,
        subStatus: updateForm.subStatus,
        assignedTo: updateForm.assignedTo.length
          ? updateForm.assignedTo.join(",")
          : "",
        createdBy: updateForm.createdBy ? String(updateForm.createdBy) : "",
        submittedBy: updateForm.submittedBy
          ? String(updateForm.submittedBy)
          : "",
        editedBy: String(userDetails.userId),
      };
      await updateTicket(selectedTicket.ticketId, payload);
      toast.success("Ticket updated successfully!");
      setShowUpdateModal(false);
      setSelectedTicket(null);
      fetchTickets();
    } catch (error) {
      console.error("Error updating ticket:", error);
      toast.error("Failed to update ticket");
    } finally {
      setLoading(false);
    }
  };

  const getPriorityBadge = (priority) => {
    const variants = {
      critical: "danger",
      high: "warning",
      medium: "primary",
      low: "secondary",
      normal: "info",
    };
    return (
      <Badge bg={variants[priority?.toLowerCase()] || "secondary"}>
        {priority}
      </Badge>
    );
  };

  const getStatusBadge = (status) => {
    const variants = {
      open: "success",
      closed: "secondary",
      "in progress": "warning",
      resolved: "info",
    };
    return (
      <Badge bg={variants[status?.toLowerCase()] || "secondary"}>
        {status}
      </Badge>
    );
  };

  const formatProjectAssigned = (projectAssigned) => {
    if (!projectAssigned) return "N/A";
    if (projectAssigned.includes(",")) {
      return projectAssigned.split(",").map((projectId, index) => {
        const projectName = getProjectNameById(projectId.trim());
        return (
          <Badge
            key={index}
            bg="outline-primary"
            className="me-1 mb-1"
            style={{ fontSize: "12px", color: "black" }}
            title={`Project ID: ${projectId.trim()}`}
          >
            {projectName}
          </Badge>
        );
      });
    }
    const projectName = getProjectNameById(projectAssigned);
    return (
      <Badge
        bg="outline-primary"
        style={{ fontSize: "12px", color: "black" }}
        title={`Project ID: ${projectAssigned}`}
      >
        {projectName}
      </Badge>
    );
  };

  const fetchTicketAttachments = async (ticketId) => {
    try {
      setLoadingAttachments((prev) => ({ ...prev, [ticketId]: true }));
      const attachmentData = await attachmentApi.getTicketAttachments(ticketId);
      if (!attachmentData || !attachmentData.attachments) {
        setAttachments((prev) => ({ ...prev, [ticketId]: null }));
        return null;
      }
      setAttachments((prev) => ({
        ...prev,
        [ticketId]: attachmentData,
      }));
      return attachmentData;
    } catch (error) {
      console.error("Error fetching attachments:", error);
      toast.error("Failed to load attachments");
      return null;
    } finally {
      setLoadingAttachments((prev) => ({ ...prev, [ticketId]: false }));
    }
  };

  const handleDownloadAttachment = async (blobUrl, fileName) => {
    try {
      const response = await attachmentApi.downloadAttachment(
        blobUrl,
        fileName,
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`Downloaded: ${fileName}`);
    } catch (error) {
      console.error("Error downloading attachment:", error);
      toast.error("Failed to download attachment");
    }
  };

  const handleViewAttachment = async (blobUrl, fileName) => {
    try {
      const response = await attachmentApi.viewAttachment(blobUrl, fileName);
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Error viewing attachment:", error);
      toast.error("Failed to view attachment");
    }
  };

  const handleShowAttachments = async (ticket) => {
    setSelectedTicket(ticket);
    setSelectedTicketAttachments([]);
    setShowAttachmentsModal(true);
    if (ticket.attachmentCount > 0 && ticket.attachmentPaths) {
      const urls = ticket.attachmentPaths.split(";");
      const names = ticket.attachmentNames
        ? ticket.attachmentNames.split(";")
        : [];
      const attachmentsList = urls.map((url, index) => ({
        url: url.trim(),
        name: names[index] ? names[index].trim() : `Attachment ${index + 1}`,
        index,
      }));
      setSelectedTicketAttachments(attachmentsList);
    } else {
      try {
        const attachmentData = await fetchTicketAttachments(ticket.ticketId);
        if (attachmentData && attachmentData.attachments) {
          const attachmentsList = attachmentData.attachments.map((att) => ({
            url: att.azureBlobUrl,
            name: att.fileName,
            size: att.fileSize,
            createdBy: att.createdBy,
            createdOn: att.createdOn,
          }));
          setSelectedTicketAttachments(attachmentsList);
        } else {
          setSelectedTicketAttachments([]);
        }
      } catch (error) {
        console.error("Error processing attachments:", error);
        setSelectedTicketAttachments([]);
      }
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return "Unknown size";
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / 1048576).toFixed(1) + " MB";
  };

  const getFileIcon = (fileName) => {
    const extension = fileName?.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "pdf":
        return "📄";
      case "doc":
      case "docx":
        return "📝";
      case "xls":
      case "xlsx":
        return "📊";
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return "🖼️";
      case "zip":
      case "rar":
        return "📦";
      case "txt":
        return "📃";
      default:
        return "📎";
    }
  };

  const filteredTickets = tickets
    .filter((t) => {
      if (!showOnlyActive) return true;
      return t.status?.toLowerCase() !== "closed";
    })
    .filter((t) => {
      const q = globalSearch.toLowerCase();
      return (
        t.ticketId?.toLowerCase().includes(q) ||
        t.ticketName?.toLowerCase().includes(q)
      );
    })
    .filter((t) => {
      if (
        filters.status.length &&
        !filters.status.some((s) => s.value === t.status)
      )
        return false;
      if (
        filters.ticketType.length &&
        !filters.ticketType.some((x) => x.value === t.ticketType)
      )
        return false;
      if (
        filters.priority.length &&
        !filters.priority.some((x) => x.value === t.priority)
      )
        return false;
      if (
        filters.assignedTo.length &&
        !filters.assignedTo.some((x) =>
          t.assignedTo?.split(",").includes(x.value),
        )
      )
        return false;
      if (
        filters.submittedBy.length &&
        !filters.submittedBy.some((x) =>
          t.submittedBy?.split(",").includes(x.value),
        )
      )
        return false;
      if (
        filters.projectAssigned.length &&
        !filters.projectAssigned.some((x) =>
          t.projectAssigned?.split(",").includes(x.value),
        )
      )
        return false;
      if (
        filters.fromMail &&
        !t.fromMail?.toLowerCase().includes(filters.fromMail.toLowerCase())
      )
        return false;
      return true;
    })
    .sort((a, b) => {
      if (!sortConfig.key) return 0;
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (sortConfig.key === "ticketTime") {
        return sortConfig.direction === "asc"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      } else {
        return { key, direction: "asc" };
      }
    });
  };

  const resolveNewValue = (log) => {
    if (!log?.newValue) return "—";
    switch (log.actionType) {
      case "TICKET_REASON_CHANGE":
        return resolveTicketReason(log.newValue);
      case "ASSIGNMENT":
        return resolveAssigneeName(log.newValue);
      default:
        return log.newValue;
    }
  };

  const resolveClosureType = (code) => {
    if (!code) return "—";
    const found = closureTypes.find((ct) => ct.codefix === code);
    return found ? found.description : code;
  };

  useEffect(() => {
    if (!tickets.length) return;
    const cpIds = new Set();
    tickets.forEach((t) => {
      ["assignedTo", "submittedBy", "createdBy"].forEach((field) => {
        if (t[field]) {
          t[field]
            .split(",")
            .map((id) => id.trim())
            .filter((id) => id.startsWith("CVCP"))
            .forEach((id) => cpIds.add(id));
        }
      });
    });
    cpIds.forEach((id) => fetchCusVenCpIfNeeded(id));
  }, [tickets]);

  const totalPages = Math.ceil(filteredTickets.length / ITEMS_PER_PAGE);

  const paginatedTickets = filteredTickets.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  const combinedUserOptions = [...assignedToOptions, ...cusVenOptions];

  const getRemainingTime = (dueTime) => {
    if (!dueTime) return "N/A";
    const now = moment.utc();
    const due = moment.utc(dueTime);
    const diff = due.diff(now);
    if (diff <= 0) return "BREACHED";
    const duration = moment.duration(diff);
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    return `${hours}h ${minutes}m`;
  };

  return (
    <div className="tickets-container">
      <Container fluid className="tickets-container__inner">
        <Card className="tickets-card">
          <Card.Header className="tickets-card__header">
            <div className="tickets-header">
              <div className="tickets-header__left">
                <h5 className="tickets-header__title">Tickets</h5>
                <Badge bg="primary" className="tickets-count">
                  {filteredTickets.length}
                </Badge>
              </div>
              <div className="tickets-header__center">
                <Form.Control
                  type="text"
                  placeholder="Search by Ticket ID, Name, Description..."
                  value={globalSearch}
                  onChange={(e) => setGlobalSearch(e.target.value)}
                  className="tickets-search"
                />
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                  className="tickets-filter-toggle"
                >
                  Advanced Filters {showAdvancedFilters ? "▲" : "▼"}
                </Button>
                <Form.Check
                  type="checkbox"
                  id="activeTicketsOnly"
                  label="Active"
                  checked={showOnlyActive}
                  onChange={(e) => setShowOnlyActive(e.target.checked)}
                  className="tickets-active-checkbox"
                />
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={handleResetFilters}
                  className="tickets-reset-btn"
                >
                  Reset
                </Button>
              </div>
              <div className="tickets-header__right">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => setShowCreateModal(true)}
                  className="tickets-create-btn"
                >
                  + Create Ticket
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  onClick={handleExportToExcel}
                  className="tickets-export-btn"
                >
                  ⬇ Export Excel
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={fetchTickets}
                  disabled={loading}
                  className="tickets-refresh-btn"
                >
                  Refresh
                </Button>
              </div>
            </div>
          </Card.Header>

          {showAdvancedFilters && (
            <Card.Body className="tickets-filters-panel">
              <Row className="g-3">
                <Col md={3}>
                  <Select
                    isMulti
                    options={statusOptions}
                    placeholder="Status"
                    value={filters.status}
                    onChange={(v) =>
                      setFilters({ ...filters, status: v || [] })
                    }
                  />
                </Col>
                <Col md={3}>
                  <Select
                    isMulti
                    placeholder="Ticket Type"
                    options={[
                      { value: "Internal", label: "Internal" },
                      { value: "Client", label: "Client" },
                      { value: "Support", label: "Support" },
                      { value: "Technical", label: "Technical" },
                    ]}
                    value={filters.ticketType}
                    onChange={(v) =>
                      setFilters({ ...filters, ticketType: v || [] })
                    }
                  />
                </Col>
                <Col md={3}>
                  <Select
                    isMulti
                    placeholder="Priority"
                    options={[
                      { value: "Low", label: "Low" },
                      { value: "Normal", label: "Normal" },
                      { value: "Medium", label: "Medium" },
                      { value: "High", label: "High" },
                      { value: "Critical", label: "Critical" },
                    ]}
                    value={filters.priority}
                    onChange={(v) =>
                      setFilters({ ...filters, priority: v || [] })
                    }
                  />
                </Col>
                <Col md={3}>
                  <Form.Control
                    placeholder="From Mail"
                    value={filters.fromMail}
                    onChange={(e) =>
                      setFilters({ ...filters, fromMail: e.target.value })
                    }
                  />
                </Col>
                <Col md={4}>
                  <Select
                    isMulti
                    placeholder="Assigned To"
                    options={combinedUserOptions}
                    value={filters.assignedTo}
                    onChange={(v) =>
                      setFilters({ ...filters, assignedTo: v || [] })
                    }
                  />
                </Col>
                <Col md={4}>
                  <Select
                    isMulti
                    placeholder="Submitted By"
                    options={combinedUserOptions}
                    value={filters.submittedBy}
                    onChange={(v) =>
                      setFilters({ ...filters, submittedBy: v || [] })
                    }
                  />
                </Col>
                <Col md={4}>
                  <Select
                    isMulti
                    placeholder="Project Assigned"
                    options={projectOptions}
                    value={filters.projectAssigned}
                    onChange={(v) =>
                      setFilters({ ...filters, projectAssigned: v || [] })
                    }
                  />
                </Col>
              </Row>
            </Card.Body>
          )}

          <Card.Body className="tickets-card__body">
            {loading ? (
              <div className="text-center">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : filteredTickets.length > 0 ? (
              <div className="tickets-table-wrapper">
                <div className="tickets-table-scroll">
                  <Table bordered hover className="tickets-table">
                    <thead className="tickets-table__head">
                      <tr>
                        <th>#</th>
                        <th
                          className="tickets-table__sortable"
                          onClick={() => handleSort("ticketId")}
                        >
                          Ticket ID{" "}
                          {sortConfig.key === "ticketId" && (
                            <span>
                              {sortConfig.direction === "asc" ? "▲" : "▼"}
                            </span>
                          )}
                        </th>
                        <th>Ticket Name</th>
                        <th
                          className="tickets-table__sortable"
                          onClick={() => handleSort("ticketTime")}
                        >
                          Ticket Time{" "}
                          {sortConfig.key === "ticketTime" && (
                            <span>
                              {sortConfig.direction === "asc" ? "▲" : "▼"}
                            </span>
                          )}
                        </th>
                        <th>Due Date</th>
                        <th>Status</th>
                        <th>Sub Status</th>
                        <th>Ticket Type</th>
                        <th>Priority</th>
                        <th>Reference To</th>
                        <th>Submitted By</th>
                        <th>Assigned To</th>
                        <th>Ticket Reason:</th>
                        <th>From Mail</th>
                        <th>Category</th>
                        <th>Project Assigned</th>
                        <th>SLA Status</th>
                        <th className="tickets-table__sticky-attachment">
                          Attachments
                        </th>
                        <th className="tickets-table__sticky-actions">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedTickets.map((ticket, index) => (
                        <tr key={index}>
                          <td>
                            {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                          </td>
                          <td>
                            <Badge bg="dark">{ticket.ticketId || "N/A"}</Badge>
                          </td>
                          <td>
                            <Link
                              className="tickets-table__link"
                              to={`/ticketinfo/${ticket.ticketId}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              title="Open ticket details"
                            >
                              {ticket.ticketName || "N/A"}
                            </Link>
                          </td>
                          <td>
                            {ticket.ticketTime
                              ? moment
                                  .utc(ticket.ticketTime)
                                  .add(5, "hours")
                                  .add(30, "minutes")
                                  .format("MMM DD, YYYY HH:mm")
                              : "N/A"}
                          </td>
                          <td>
                            {ticket.dueDate
                              ? moment(ticket.dueDate).format("MMM DD, YYYY")
                              : "N/A"}
                          </td>
                          <td>{getStatusBadge(ticket.status)}</td>
                          <td>
                            <Badge bg="secondary">
                              {ticket.subStatus || "N/A"}
                            </Badge>
                          </td>
                          <td>
                            <Badge bg="outline-info" style={{ color: "black" }}>
                              {resolveTicketType(ticket.ticketType)}
                            </Badge>
                          </td>
                          <td>{getPriorityBadge(ticket.priority)}</td>
                          <td>{ticket.referenceTo || "N/A"}</td>
                          <td>{resolveAssigneeName(ticket.submittedBy)}</td>
                          <td>{resolveAssigneeName(ticket.assignedTo)}</td>
                          <td>{resolveTicketReason(ticket.ticketReason)}</td>
                          <td>
                            {ticket.fromMails && ticket.fromMails.length > 0
                              ? ticket.fromMails.map((email, i) => (
                                  <Badge
                                    bg="light"
                                    text="dark"
                                    key={i}
                                    className="me-1"
                                  >
                                    {email}
                                  </Badge>
                                ))
                              : ticket.fromMail || "N/A"}
                          </td>
                          <td>
                            <Badge bg="info">
                              {resolveCategoryName(ticket.category)}
                            </Badge>
                          </td>
                          <td>
                            {formatProjectAssigned(ticket.projectAssigned)}
                          </td>
                          <td>
                            {ticket.slaStatus === "Breached" ? (
                              <Badge bg="danger">Breached</Badge>
                            ) : ticket.slaStatus === "Running" ? (
                              <Badge bg="success">Running</Badge>
                            ) : (
                              <Badge bg="secondary">Completed</Badge>
                            )}
                            <div style={{ fontSize: "12px" }}>
                              {getRemainingTime(ticket.responseDueTime) ||
                                "N/A"}
                            </div>
                          </td>
                          <td className="tickets-table__sticky-attachment">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleShowAttachments(ticket)}
                              disabled={loadingAttachments[ticket.ticketId]}
                              className="tickets-table__attach-btn"
                            >
                              {loadingAttachments[ticket.ticketId] ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                "View"
                              )}
                            </Button>
                          </td>
                          <td className="tickets-table__sticky-actions">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleEditTicket(ticket)}
                              className="tickets-table__edit-btn"
                            >
                              Edit
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                {totalPages > 1 && (
                  <div className="tickets-pagination">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      className="tickets-pagination__prev"
                    >
                      ◀ Prev
                    </Button>
                    <div className="tickets-pagination__info">
                      Page <strong>{currentPage}</strong> of{" "}
                      <strong>{totalPages}</strong>
                    </div>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      disabled={currentPage === totalPages}
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                      className="tickets-pagination__next"
                    >
                      Next ▶
                    </Button>
                  </div>
                )}
              </div>
            ) : (
              <Alert variant="info" className="text-center">
                No tickets found.
              </Alert>
            )}
          </Card.Body>
        </Card>

        {/* Modals remain unchanged */}
        <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Organization Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Email Type</Form.Label>
                <Form.Select
                  value={newEmail.emailType}
                  onChange={(e) =>
                    setNewEmail({ ...newEmail, emailType: e.target.value })
                  }
                >
                  <option value="">Select email type...</option>
                  <option value="support">Support</option>
                  <option value="sales">Sales</option>
                  <option value="general">General</option>
                  <option value="billing">Billing</option>
                  <option value="technical">Technical</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email address"
                  value={newEmail.emailId}
                  onChange={(e) =>
                    setNewEmail({ ...newEmail, emailId: e.target.value })
                  }
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowEmailModal(false)}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddEmail}>
              Add Email
            </Button>
          </Modal.Footer>
        </Modal>

        <TicketEditModal
          show={showUpdateModal}
          onClose={() => setShowUpdateModal(false)}
          ticket={selectedTicket}
          orgId={orgId}
          userDetails={userDetails}
          projectOptions={projectOptions}
          ticketAssignees={ticketAssignees}
          assigneeOptionsByProject={assigneeOptionsByProject}
          fetchProjectAndPartners={fetchProjectAndPartners}
          refreshTickets={fetchTickets}
        />

        <TicketCreateModal
          show={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          orgId={orgId}
          userDetails={userDetails}
          projectOptions={projectOptions}
          assigneeOptionsByProject={assigneeOptionsByProject}
          refreshTickets={fetchTickets}
        />

        <Modal
          show={showAttachmentsModal}
          onHide={() => setShowAttachmentsModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Attachments for Ticket: {selectedTicket?.ticketId || "Unknown"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedTicketAttachments &&
            selectedTicketAttachments.length > 0 ? (
              <div>
                <p className="text-muted mb-3">
                  {selectedTicketAttachments.length} attachment(s) found
                  {attachments[selectedTicket?.ticketId]?.TotalAttachmentSize >
                    0 &&
                    ` • Total size: ${formatFileSize(
                      attachments[selectedTicket?.ticketId]
                        ?.totalAttachmentSize,
                    )}`}
                </p>
                <div className="attachments-list">
                  {selectedTicketAttachments.map((attachment, index) => (
                    <Card key={index} className="mb-2">
                      <Card.Body className="py-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span
                              className="me-2"
                              style={{ fontSize: "1.2em" }}
                            >
                              {getFileIcon(attachment.name)}
                            </span>
                            <div>
                              <div className="fw-bold">{attachment.name}</div>
                              <small className="text-muted">
                                {formatFileSize(attachment.size)} • Uploaded by{" "}
                                {attachment.createdBy}
                              </small>
                            </div>
                          </div>
                          <div>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              className="me-1"
                              onClick={() =>
                                handleViewAttachment(
                                  attachment.url,
                                  attachment.name,
                                )
                              }
                              title="View in browser"
                              disabled={!attachment.url}
                            >
                              👁️ View
                            </Button>
                            <Button
                              variant="outline-success"
                              size="sm"
                              onClick={() =>
                                handleDownloadAttachment(
                                  attachment.url,
                                  attachment.name,
                                )
                              }
                              title="Download file"
                              disabled={!attachment.url}
                            >
                              ⬇️ Download
                            </Button>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                </div>
              </div>
            ) : (
              <div className="text-center py-4">
                <div className="text-muted">
                  No attachments found for this ticket
                </div>
                <small className="text-muted">
                  This ticket either has no attachments or the attachment data
                  is not available.
                </small>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowAttachmentsModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showClosureModal}
          onHide={() => setShowClosureModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Close Ticket</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Closure Type</Form.Label>
              <Select
                options={closureTypeOptions}
                isLoading={loadingClosureTypes}
                value={closureTypeOptions.find(
                  (opt) => opt.value === closureForm.closureTypeCode,
                )}
                onChange={(opt) =>
                  setClosureForm({
                    ...closureForm,
                    closureTypeCode: opt?.value || "",
                  })
                }
                placeholder="Select closure type..."
              />
            </Form.Group>
            <hr />
            <h6 className="mb-2">Work Effort Details</h6>
            {closureForm.efforts.map((effort, index) => (
              <Row key={index} className="align-items-end mb-2">
                <Col md={5}>
                  <Form.Label>Worked By</Form.Label>
                  <Select
                    options={ticketAssignees}
                    value={ticketAssignees.find(
                      (o) => o.value === effort.workedBy,
                    )}
                    onChange={(opt) =>
                      updateEffortRow(index, "workedBy", opt?.value)
                    }
                    placeholder="Select user..."
                    isClearable
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>Effort</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.25"
                    value={effort.effortValue}
                    onChange={(e) =>
                      updateEffortRow(index, "effortValue", e.target.value)
                    }
                  />
                </Col>
                <Col md={2}>
                  <Form.Label>Unit</Form.Label>
                  <Form.Select
                    value={effort.effortUnit}
                    onChange={(e) =>
                      updateEffortRow(index, "effortUnit", e.target.value)
                    }
                  >
                    <option value="HOURS">Hours</option>
                    <option value="DAYS">Days</option>
                  </Form.Select>
                </Col>
                <Col md={2}>
                  <Button
                    variant="outline-danger"
                    onClick={() => removeEffortRow(index)}
                    disabled={closureForm.efforts.length === 1}
                  >
                    ✕
                  </Button>
                </Col>
              </Row>
            ))}
            <Button variant="outline-primary" size="sm" onClick={addEffortRow}>
              + Add Member Effort
            </Button>
            <hr />
            <Form.Group className="mb-3 mt-3">
              <Form.Label>Closure Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={closureForm.closureRemarks}
                onChange={(e) =>
                  setClosureForm({
                    ...closureForm,
                    closureRemarks: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowClosureModal(false)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmClosure}>
              Close Ticket
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showWorkLogModal}
          onHide={() => setShowWorkLogModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Work Log</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Worked By</Form.Label>
              <Select
                options={ticketAssignees}
                value={ticketAssignees.find(
                  (o) => o.value === workLogForm.workedBy,
                )}
                onChange={(opt) =>
                  setWorkLogForm({
                    ...workLogForm,
                    workedBy: opt?.value || "",
                  })
                }
                placeholder="Select user..."
              />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Effort</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.25"
                    value={workLogForm.effortValue}
                    onChange={(e) =>
                      setWorkLogForm({
                        ...workLogForm,
                        effortValue: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Unit</Form.Label>
                  <Form.Select
                    value={workLogForm.effortUnit}
                    onChange={(e) =>
                      setWorkLogForm({
                        ...workLogForm,
                        effortUnit: e.target.value,
                      })
                    }
                  >
                    <option value="HOURS">Hours</option>
                    <option value="DAYS">Days</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={workLogForm.remarks}
                onChange={(e) =>
                  setWorkLogForm({
                    ...workLogForm,
                    remarks: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowWorkLogModal(false)}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddWorkLog}>
              Save Work Log
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};;;

export default ViewTickets;



// import { useEffect, useState } from "react";
// import {
//   Container,
//   Table,
//   Button,
//   Card,
//   Row,
//   Col,
//   Badge,
//   Alert,
//   Spinner,
//   Modal,
//   Form,
// } from "react-bootstrap";
// import { toast } from "react-toastify";
// import moment from "moment";
// import {
//   getTicketsByOrgId,
//   organizationEmailApi,
//   emailProcessingApi,
//   createTicket,
//   updateTicket,
//   attachmentApi,
//   getTicketsByAssignedResource,
//   addTicketLog,
//   closeTicket,
//   getTicketsByFromMail,
//   addTicketWorkLog,
//   getTicketSla,
//   getTicketSlaLogs,
// } from "../Api/TicketApiOrg";
// import {
//   fetchCusVenCpById,
//   fetchCusVenCpByOrgId,
// } from "../Api/CusVenCpMasterApi";

// import TicketCreateModal from "./TicketCreateModal";

// import "./Ticket.css";

// import { Link } from "react-router-dom";

// import { useAuth } from "../Context/AuthContext";
// import { fetchProjectsByOrg } from "../Api/ViewProjects";
// import Select from "react-select";
// import { fetchProjectDetails } from "../Api/ViewProjects";
// import { getPartnersByProject } from "../Api/PartnerMaster";
// import { fetchCusVenCpByCusVenType } from "../Api/CusVenCpMasterApi";
// import { getTeamById } from "../Api/TeamMaster";
// import { getUserById } from "../Api/Auth";
// import { getResourceByMavUserId } from "../Api/ResourceList";
// import { fetchResourceById } from "../Api/ResourceMaster";
// import { getResourcesByOrgId } from "../Api/ResourceList";
// import { getAllTicketClosureTypes } from "../Api/TicketApiOrg";
// import { getAllTicketLoggedTypes } from "../Api/TicketApiOrg";
// import { getTicketLogsByTicketId } from "../Api/TicketApiOrg";
// import { getTasksByTicketId } from "../Api/TicketApiOrg";
// import { useNavigate } from "react-router-dom";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// import TicketEditModal from "./TicketEditModal";

// const ViewTickets = () => {
//   const navigate = useNavigate();
//   const [tickets, setTickets] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [projects, setProjects] = useState([]);

//   const userDetails = JSON.parse(localStorage.getItem("userDetails"));
//   const userId = userDetails?.userId;
//   const orgId = userDetails?.organisationId;

//   const loggedInEmail = userDetails?.email?.toLowerCase();

//   const [showCreateModal, setShowCreateModal] = useState(false);

//   const [connectionStatus, setConnectionStatus] = useState(null);
//   const [organizationEmails, setOrganizationEmails] = useState([]);
//   const [showEmailModal, setShowEmailModal] = useState(false);
//   const [showUpdateModal, setShowUpdateModal] = useState(false);
//   const [showTicketInfoModal, setShowTicketInfoModal] = useState(false);
//   const [selectedTicket, setSelectedTicket] = useState(null);
//   const [newEmail, setNewEmail] = useState({ emailType: "", emailId: "" });
//   const [testResults, setTestResults] = useState(null);
//   const [projectPartnerMap, setProjectPartnerMap] = useState({});
//   const [assigneeOptionsByProject, setAssigneeOptionsByProject] = useState({});
//   const [userCache, setUserCache] = useState({});
//   const [ticketAssignees, setTicketAssignees] = useState([]);
//   const [assignedToOptions, setAssignedToOptions] = useState([]);
//   const [showClosureModal, setShowClosureModal] = useState(false);

//   const [closureTypes, setClosureTypes] = useState([]);
//   const [loadingClosureTypes, setLoadingClosureTypes] = useState(false);

//   const [ticketLoggedTypes, setTicketLoggedTypes] = useState([]);
//   const [loadingTicketReasons, setLoadingTicketReasons] = useState(false);

//   const [ticketLogs, setTicketLogs] = useState([]);
//   const [loadingLogs, setLoadingLogs] = useState(false);

//   const [ticketTasks, setTicketTasks] = useState([]);
//   const [loadingTasks, setLoadingTasks] = useState(false);

//   const [ticketSla, setTicketSla] = useState(null);
//   const [slaLogs, setSlaLogs] = useState([]);

//   const [globalSearch, setGlobalSearch] = useState("");

//   const [cusVenCpCache, setCusVenCpCache] = useState({});

//   const ITEMS_PER_PAGE = 100;

//   const [currentPage, setCurrentPage] = useState(1);

//   const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

//   const [filterUserOptions, setFilterUserOptions] = useState([]);

//   const [cusVenOptions, setCusVenOptions] = useState([]);

//   const [showOnlyActive, setShowOnlyActive] = useState(true);

//   const STATUS_SUBSTATUS_MAP = {
//     Open: ["New", "Awaiting Assignment", "Assigned", "Pending Triage"],
//     "In Progress": [
//       "Investigation Ongoing",
//       "Work in Progress",
//       "Pending Customer Input",
//       "Blocked",
//       "Reopened",
//     ],
//     Resolved: ["Fixed", "Workaround Provided", "Duplicate", "Cannot Reproduce"],
//     Closed: ["Successfully Closed", "Auto Closed", "Rejected"],
//   };

//   const [filters, setFilters] = useState({
//     status: [],
//     ticketType: [],
//     priority: [],
//     submittedBy: [],
//     assignedTo: [],
//     fromMail: "",
//     projectAssigned: [],
//   });

//   const [showWorkLogModal, setShowWorkLogModal] = useState(false);

//   const [workLogForm, setWorkLogForm] = useState({
//     workedBy: "",
//     effortValue: "",
//     effortUnit: "HOURS",
//     remarks: "",
//   });

//   const resetTicketScopedState = () => {
//     setTicketAssignees([]);
//     setUpdateForm({
//       ticketName: "",
//       description: "",
//       status: "",
//       priority: "",
//       assignedTo: [],
//       createdBy: "",
//       submittedBy: "",
//       category: "",
//       dueDate: "",
//       referenceTo: "",
//       projectAssigned: "",
//       ticketType: "",
//       ticketReason: "",
//     });
//   };

//   const [closureForm, setClosureForm] = useState({
//     closureTypeCode: "",
//     closureRemarks: "",
//     efforts: [
//       {
//         workedBy: "",
//         effortValue: "",
//         effortUnit: "HOURS",
//       },
//     ],
//   });

//   const addEffortRow = () => {
//     setClosureForm((prev) => ({
//       ...prev,
//       efforts: [
//         ...prev.efforts,
//         { workedBy: "", effortValue: "", effortUnit: "HOURS" },
//       ],
//     }));
//   };

//   const removeEffortRow = (index) => {
//     setClosureForm((prev) => ({
//       ...prev,
//       efforts: prev.efforts.filter((_, i) => i !== index),
//     }));
//   };

//   const updateEffortRow = (index, field, value) => {
//     const updated = [...closureForm.efforts];
//     updated[index][field] = value;

//     setClosureForm((prev) => ({
//       ...prev,
//       efforts: updated,
//     }));
//   };

//   const [updateForm, setUpdateForm] = useState({
//     ticketName: "",
//     description: "",
//     status: "",
//     priority: "",
//     assignedTo: [],
//     createdBy: "",
//     submittedBy: "",
//     category: "",
//     dueDate: "",
//     referenceTo: "",
//     projectAssigned: "",
//     ticketType: "",
//     ticketReason: "",
//     subStatus: "",
//   });
//   const { user } = useAuth();
//   const [attachments, setAttachments] = useState({});
//   const [loadingAttachments, setLoadingAttachments] = useState({});
//   const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
//   const [selectedTicketAttachments, setSelectedTicketAttachments] = useState(
//     [],
//   );
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [statusFilter, setStatusFilter] = useState([]);
//   const statusOptions = [
//     { value: "Open", label: "Open" },
//     { value: "In Progress", label: "In Progress" },
//     { value: "Resolved", label: "Resolved" },
//     { value: "Closed", label: "Closed" },
//   ];

//   const EXCLUDED_PROJECT_STATUSES = ["S009", "S010"];

//   const normalizeToOptions = (items, mapper, sourceLabel) => {
//     return items.map((item) => ({
//       value: mapper.value(item),
//       label: `${mapper.label(item)} (${sourceLabel})`,
//     }));
//   };

//   const fetchTicketLoggedTypes = async () => {
//     try {
//       setLoadingTicketReasons(true);
//       const res = await getAllTicketLoggedTypes();
//       const activeTypes = (res || []).filter((x) => x.active === true);
//       setTicketLoggedTypes(activeTypes);
//     } catch (error) {
//       console.error("❌ Failed to load ticket logged types", error);
//       toast.error("Failed to load ticket reasons");
//     } finally {
//       setLoadingTicketReasons(false);
//     }
//   };

//   const fetchCusVenCpIfNeeded = async (cpId) => {
//     if (!cpId || !cpId.startsWith("CVCP")) return null;
//     if (cusVenCpCache[cpId]) {
//       return cusVenCpCache[cpId];
//     }
//     try {
//       const cp = await fetchCusVenCpById(cpId);
//       if (cp?.contactPerName) {
//         setCusVenCpCache((prev) => ({
//           ...prev,
//           [cpId]: cp.contactPerName,
//         }));
//         return cp.contactPerName;
//       }
//     } catch (err) {
//       console.error("❌ Failed to fetch CP:", cpId, err);
//     }
//     return cpId;
//   };

//   useEffect(() => {
//     fetchCusVenContactPersonsByOrg();
//   }, [orgId]);

//   const fetchCusVenContactPersonsByOrg = async () => {
//     try {
//       if (!orgId) return;
//       const cpData = await fetchCusVenCpByOrgId(orgId);
//       if (!Array.isArray(cpData)) return;
//       const formatted = cpData.map((cp) => ({
//         value: cp.cusVenId,
//         label: `${cp.contactPerName} (Contact Person)`,
//       }));
//       setCusVenOptions(formatted);
//     } catch (error) {
//       console.error("❌ Failed to fetch CusVen CP by Org", error);
//     }
//   };

//   const resolveAssigneeNameAsync = async (ids) => {
//     if (!ids) return "N/A";
//     const idArray =
//       typeof ids === "string" ? ids.split(",").map((i) => i.trim()) : ids;
//     const names = await Promise.all(
//       idArray.map(async (id) => {
//         if (id.startsWith("CVCP")) {
//           return await fetchCusVenCpIfNeeded(id);
//         }
//         const match = assignedToOptions.find((opt) => opt.value === id);
//         return match ? match.label.replace(/\s*\(.*\)$/, "") : id;
//       }),
//     );
//     return names.join(", ");
//   };

//   const fetchClosureTypes = async () => {
//     try {
//       setLoadingClosureTypes(true);
//       const res = await getAllTicketClosureTypes();
//       const activeTypes = (res?.data || []).filter((x) => x.active === true);
//       setClosureTypes(activeTypes);
//     } catch (error) {
//       console.error("❌ Failed to fetch closure types", error);
//       toast.error("Failed to load closure types");
//     } finally {
//       setLoadingClosureTypes(false);
//     }
//   };

//   const projectOptions = projects
//     .filter(
//       (project) => !EXCLUDED_PROJECT_STATUSES.includes(project.projectStatus),
//     )
//     .sort((a, b) =>
//       (a.prTitle || "").localeCompare(b.prTitle || "", undefined, {
//         sensitivity: "base",
//       }),
//     )
//     .map((project) => ({
//       value: project.projectId,
//       label: `${project.prTitle} (${project.projectId})`,
//     }));

//   const hasAdminTicketRole = () => {
//     return (
//       Array.isArray(userDetails?.roles) &&
//       userDetails.roles.includes("Admin Ticket")
//     );
//   };

//   const resolveNameWithId = (ids) => {
//     if (!ids) return "";
//     const idArray =
//       typeof ids === "string" ? ids.split(",").map((i) => i.trim()) : ids;
//     return idArray
//       .map((id) => {
//         if (id.startsWith("CVCP")) {
//           const name = cusVenCpCache[id];
//           return name ? `${name} (${id})` : id;
//         }
//         const match = assignedToOptions.find((opt) => opt.value === id);
//         if (match) {
//           const cleanName = match.label.replace(/\s*\(.*\)$/, "");
//           return `${cleanName} (${id})`;
//         }
//         return id;
//       })
//       .join(", ");
//   };

//   const resolveProjectWithId = (projectAssigned) => {
//     if (!projectAssigned) return "";
//     const projectIds = projectAssigned.split(",").map((id) => id.trim());
//     return projectIds
//       .map((projectId) => {
//         const project = projects.find(
//           (p) => p.projectId === projectId || p.prozmaPrId === projectId,
//         );
//         return project ? `${project.prTitle} (${projectId})` : projectId;
//       })
//       .join(", ");
//   };

//   const handleAddWorkLog = async () => {
//     try {
//       if (!workLogForm.workedBy || !workLogForm.effortValue) {
//         toast.error("Please fill all required fields");
//         return;
//       }
//       const now = moment();
//       const payload = {
//         ticketId: selectedTicket.ticketId,
//         orgId: String(orgId),
//         createdBy: String(userDetails.userId),
//         changedBy: String(userDetails.userId),
//         changedDate: now.format("YYYY-MM-DD"),
//         changedTime: now.format("HH:mm:ss"),
//         workedBy: workLogForm.workedBy,
//         effortValue: Number(workLogForm.effortValue),
//         effortUnit: workLogForm.effortUnit,
//         closureRemarks: workLogForm.remarks,
//       };
//       await addTicketWorkLog(payload);
//       toast.success("Work log added successfully!");
//       setShowWorkLogModal(false);
//       setWorkLogForm({
//         workedBy: "",
//         effortValue: "",
//         effortUnit: "HOURS",
//         remarks: "",
//       });
//       if (selectedTicket) {
//         const logs = await getTicketLogsByTicketId(selectedTicket.ticketId);
//         setTicketLogs(logs || []);
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to add work log");
//     }
//   };

//   const handleConfirmClosure = async () => {
//     try {
//       if (!closureForm.closureTypeCode) {
//         toast.error("Closure type is required");
//         return;
//       }
//       if (
//         closureForm.efforts.some(
//           (e) => !e.workedBy || !e.effortValue || e.effortValue <= 0,
//         )
//       ) {
//         toast.error("Please fill all effort details");
//         return;
//       }
//       const payload = {
//         ticketId: selectedTicket.ticketId,
//         orgId,
//         closureTypeCode: closureForm.closureTypeCode,
//         closureRemarks: closureForm.closureRemarks,
//         createdBy: String(userDetails.userId),
//         efforts: closureForm.efforts.map((e) => ({
//           workedBy: e.workedBy,
//           effortValue: Number(e.effortValue),
//           effortUnit: e.effortUnit,
//         })),
//       };
//       console.log("🟢 Closing ticket with payload:", payload);
//       await closeTicket(payload);
//       toast.success("Ticket closed successfully!");
//       setShowClosureModal(false);
//       setShowUpdateModal(false);
//       fetchTickets();
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to close ticket");
//     }
//   };

//   const handleExportToExcel = () => {
//     if (!filteredTickets.length) {
//       toast.info("No tickets to export");
//       return;
//     }
//     const formattedData = filteredTickets.map((ticket, index) => ({
//       "S.No": index + 1,
//       "Ticket ID": ticket.ticketId,
//       "Ticket Name": ticket.ticketName,
//       "Ticket Time": ticket.ticketTime
//         ? moment(ticket.ticketTime).format("YYYY-MM-DD HH:mm")
//         : "",
//       Status: ticket.status,
//       Priority: ticket.priority,
//       "Ticket Type": ticket.ticketType,
//       "Submitted By": resolveNameWithId(ticket.submittedBy),
//       "Assigned To": resolveNameWithId(ticket.assignedTo),
//       "From Mail": ticket.fromMail,
//       Category: ticket.category,
//       "Project Assigned": resolveProjectWithId(ticket.projectAssigned),
//       "Ticket Reason": resolveTicketReason(ticket.ticketReason),
//       "Due Date": ticket.dueDate
//         ? moment(ticket.dueDate).format("YYYY-MM-DD")
//         : "",
//     }));
//     const worksheet = XLSX.utils.json_to_sheet(formattedData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Tickets");
//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array",
//     });
//     const data = new Blob([excelBuffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });
//     saveAs(data, `Tickets_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
//   };

//   const buildAssignedToOptions = async () => {
//     try {
//       if (!userDetails?.userId || !orgId) return;
//       const options = [];
//       const seen = new Set();
//       const resResponse = await getResourceByMavUserId(userDetails.userId);
//       const selfResource = resResponse?.resource;
//       if (!selfResource?.resourceId) {
//         console.warn("❌ Resource not found for logged-in user");
//         return;
//       }
//       const addOption = (resource, suffix = "") => {
//         if (!resource?.resourceId || seen.has(resource.resourceId)) return;
//         options.push({
//           value: resource.resourceId,
//           label: suffix ? `${resource.name} (${suffix})` : resource.name,
//         });
//         seen.add(resource.resourceId);
//       };
//       addOption(selfResource, "You");
//       if (selfResource.lineManager) {
//         const lm = await fetchResourceById(selfResource.lineManager);
//         addOption(lm, "Line Manager");
//       }
//       if (selfResource.dotLineManager) {
//         const dlm = await fetchResourceById(selfResource.dotLineManager);
//         addOption(dlm, "Dot Line Manager");
//       }
//       const orgResResponse = await getResourcesByOrgId(orgId);
//       const orgResources = Array.isArray(orgResResponse)
//         ? orgResResponse
//         : orgResResponse?.resources || [];
//       orgResources.forEach((res) => {
//         addOption(res);
//       });
//       const pinned = options.filter((o) => o.label.includes("(You)"));
//       const rest = options
//         .filter((o) => !o.label.includes("(You)"))
//         .sort((a, b) => a.label.localeCompare(b.label));
//       const finalOptions = [...pinned, ...rest];
//       console.log("✅ Final AssignedTo Options:", finalOptions);
//       setAssignedToOptions(finalOptions);
//     } catch (error) {
//       console.error("❌ Failed to build Assigned To options", error);
//     }
//   };

//   const getSelectedProjectOptions = () => {
//     if (!updateForm.projectAssigned) return [];
//     const selectedIds = updateForm.projectAssigned.split(",");
//     return projectOptions.filter((opt) => selectedIds.includes(opt.value));
//   };

//   const handleProjectSelectChange = (selectedOptions) => {
//     const ids = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
//     setUpdateForm({
//       ...updateForm,
//       projectAssigned: ids.join(","),
//     });
//   };

//   useEffect(() => {
//     if (user?.organisationId) {
//       fetchTickets();
//       fetchOrganizationEmails();
//       fetchOrganizationProjects();
//     }
//   }, [user]);

//   const fetchTickets = async () => {
//     try {
//       setLoading(true);
//       if (hasAdminTicketRole()) {
//         const data = await getTicketsByOrgId(orgId);
//         setTickets(data || []);
//         console.log("✅ Admin view - fetched all tickets:", data);
//         return;
//       }
//       const combinedMap = new Map();
//       try {
//         const res = await getResourceByMavUserId(userDetails.userId);
//         const resourceId = res?.resource?.resourceId;
//         if (resourceId) {
//           const assignedTickets =
//             await getTicketsByAssignedResource(resourceId);
//           (assignedTickets || []).forEach((t) =>
//             combinedMap.set(t.ticketId, t),
//           );
//         }
//       } catch (e) {
//         console.warn("No assigned tickets");
//       }
//       if (loggedInEmail) {
//         try {
//           const allTickets = await getTicketsByOrgId(orgId);
//           (allTickets || []).forEach((t) => {
//             const emails = [
//               ...(t.fromMails || []),
//               ...(t.fromMail ? [t.fromMail] : []),
//             ]
//               .map((e) => e?.toLowerCase().trim())
//               .filter(Boolean);
//             if (emails.includes(loggedInEmail)) {
//               combinedMap.set(t.ticketId, t);
//             }
//           });
//         } catch (e) {
//           console.warn("No FromMail tickets");
//         }
//       }
//       setTickets([...combinedMap.values()]);
//     } catch (err) {
//       console.error("❌ Failed to load tickets", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchOrganizationProjects = async () => {
//     try {
//       if (!user?.organisationId) return;
//       const projectsData = await fetchProjectsByOrg(user.organisationId);
//       setProjects(projectsData);
//       console.log("✅ Fetched organization projects:", projectsData);
//     } catch (error) {
//       console.error("Error fetching organization projects:", error);
//       toast.error("Failed to load projects");
//     }
//   };

//   const getProjectNameById = (projectId) => {
//     if (!projectId) return "N/A";
//     const project = projects.find(
//       (proj) => proj.projectId === projectId || proj.prozmaPrId === projectId,
//     );
//     return project ? project.prTitle : projectId;
//   };

//   const getProjectDetailsById = (projectId) => {
//     if (!projectId) return null;
//     return projects.find(
//       (proj) => proj.projectId === projectId || proj.prozmaPrId === projectId,
//     );
//   };

//   const fetchProjectAndPartners = async (projectId) => {
//     try {
//       console.log("🟢 fetchProjectAndPartners START for:", projectId);
//       if (projectPartnerMap[projectId]) {
//         console.log("⚠️ Project already cached, skipping:", projectId);
//         return;
//       }
//       const localOptions = [];
//       const projectDetails = await fetchProjectDetails(projectId);
//       console.log("📌 Project Details:", projectDetails);
//       console.log("👥 teamAssigned (project):", projectDetails?.teamAssigned);
//       if (projectDetails?.prClient) {
//         const clientCPs = await fetchCusVenContactPersons(
//           projectDetails.prClient,
//           "Project Client",
//         );
//         if (Array.isArray(clientCPs)) {
//           localOptions.push(
//             ...normalizeToOptions(
//               clientCPs,
//               {
//                 value: (cp) => cp.cusVenId,
//                 label: (cp) => cp.contactPerName,
//               },
//               "Client",
//             ),
//           );
//         }
//       }
//       let partners = [];
//       try {
//         partners = await getPartnersByProject(projectId);
//         console.log("🤝 Partners:", partners);
//       } catch (error) {
//         if (error?.response?.status === 404) {
//           console.warn("⚠️ No partners for project:", projectId);
//           partners = [];
//         } else {
//           throw error;
//         }
//       }
//       if (Array.isArray(partners)) {
//         for (const partner of partners) {
//           if (partner?.partnerName) {
//             const partnerCPs = await fetchCusVenContactPersons(
//               partner.partnerName,
//               "Partner",
//             );
//             if (Array.isArray(partnerCPs)) {
//               localOptions.push(
//                 ...normalizeToOptions(
//                   partnerCPs,
//                   {
//                     value: (cp) => cp.cusVenId,
//                     label: (cp) => cp.contactPerName,
//                   },
//                   "Partner",
//                 ),
//               );
//             }
//           }
//         }
//       }
//       if (projectDetails?.teamAssigned) {
//         const teamData = await getTeamById(projectDetails.teamAssigned);
//         console.log("✅ Team API Response:", teamData);
//         console.log("👤 Team Members IDs:", teamData?.teamMembers);
//         if (Array.isArray(teamData?.teamMembers)) {
//           for (const memberId of teamData.teamMembers) {
//             const user = await fetchUserIfNeeded(memberId);
//             if (!user) continue;
//             const res = await getResourceByMavUserId(user.userId);
//             const resource = res?.resource;
//             if (!resource?.resourceId) continue;
//             localOptions.push({
//               value: resource.resourceId,
//               label: `${resource.name} (Team)`,
//             });
//           }
//         }
//       }
//       console.log(
//         "🟢 FINAL assignee options for project",
//         projectId,
//         localOptions,
//       );
//       setAssigneeOptionsByProject((prev) => {
//         const existing = prev[projectId] || [];
//         const map = new Map();
//         existing.forEach((opt) => map.set(opt.value, opt));
//         localOptions.forEach((opt) => map.set(opt.value, opt));
//         return {
//           ...prev,
//           [projectId]: Array.from(map.values()),
//         };
//       });
//       setProjectPartnerMap((prev) => ({
//         ...prev,
//         [projectId]: {
//           projectDetails,
//           partners,
//         },
//       }));
//       console.log("🟢 Building assignee options for project:", projectId);
//       console.log("Final assignee options:", localOptions);
//     } catch (error) {
//       console.error("❌ Error fetching project/partners/team:", error);
//     }
//   };

//   const fetchUserIfNeeded = async (userId) => {
//     if (!userId) return null;
//     if (userCache[userId]) {
//       return userCache[userId];
//     }
//     try {
//       console.log("🔹 Fetching user by ID:", userId);
//       const response = await getUserById(userId);
//       const user = response?.user;
//       if (!user) return null;
//       setUserCache((prev) => ({
//         ...prev,
//         [userId]: user,
//       }));
//       return user;
//     } catch (error) {
//       console.error(`❌ Failed to fetch user ${userId}`, error);
//       return null;
//     }
//   };

//   const getAssigneesForTicket = (ticket) => {
//     if (!ticket?.projectAssigned) return [];
//     const projectIds = ticket.projectAssigned.split(",").map((id) => id.trim());
//     const map = new Map();
//     projectIds.forEach((pid) => {
//       const assignees = assigneeOptionsByProject?.[pid] || [];
//       assignees.forEach((opt) => map.set(opt.value, opt));
//     });
//     return Array.from(map.values());
//   };

//   const fetchOrganizationEmails = async () => {
//     try {
//       const emails = await organizationEmailApi.getEmailsByOrgId(
//         user.organisationId,
//       );
//       setOrganizationEmails(emails);
//     } catch (error) {
//       console.error("Error fetching organization emails:", error);
//     }
//   };

//   const fetchCusVenContactPersons = async (cusVenTypeId, label = "") => {
//     try {
//       if (!cusVenTypeId) return [];
//       console.log(`🔹 Fetching CusVen CP for ${label}:`, cusVenTypeId);
//       const cpData = await fetchCusVenCpByCusVenType(cusVenTypeId);
//       console.log(`✅ CusVen Contact Persons (${label}):`, cpData);
//       return Array.isArray(cpData) ? cpData : [];
//     } catch (error) {
//       if (error?.response?.status === 404) {
//         console.warn(
//           `⚠️ No contact persons found for ${label} (${cusVenTypeId})`,
//         );
//         return [];
//       }
//       console.error(
//         `❌ Error fetching CusVen CP for ${label} (${cusVenTypeId})`,
//         error,
//       );
//       return [];
//     }
//   };

//   const resolveAssigneeName = (ids) => {
//     if (!ids) return "N/A";
//     const idArray =
//       typeof ids === "string" ? ids.split(",").map((i) => i.trim()) : ids;
//     return idArray
//       .map((id) => {
//         if (id.startsWith("CVCP")) {
//           return cusVenCpCache[id] || id;
//         }
//         const match = assignedToOptions.find((opt) => opt.value === id);
//         return match ? match.label.replace(/\s*\(.*\)$/, "") : id;
//       })
//       .join(", ");
//   };

//   const addFallbackAssignees = (projectId, localOptions) => {
//     const fallback = [];
//     if (userId) {
//       fallback.push({
//         value: String(userId),
//         label: "You (Current User)",
//       });
//     }
//     if (selectedTicket?.createdBy) {
//       fallback.push({
//         value: String(selectedTicket.createdBy),
//         label: "Ticket Creator",
//       });
//     }
//     const map = new Map();
//     [...localOptions, ...fallback].forEach((opt) => map.set(opt.value, opt));
//     return Array.from(map.values());
//   };

//   const handleResetFilters = () => {
//     setGlobalSearch("");
//     setShowOnlyActive(true);
//     setCurrentPage(1);
//     setFilters({
//       status: [],
//       ticketType: [],
//       priority: [],
//       submittedBy: [],
//       assignedTo: [],
//       fromMail: "",
//       projectAssigned: [],
//     });
//     setSortConfig({ key: null, direction: "asc" });
//   };

//   const handleProcessEmails = async () => {
//     try {
//       setLoading(true);
//       await emailProcessingApi.processOrganizationEmails(user.organisationId);
//       toast.success("Email processing started successfully!");
//       setTimeout(() => fetchTickets(), 2000);
//     } catch (error) {
//       console.error("Error processing emails:", error);
//       toast.error("Failed to process emails");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [globalSearch, filters, showOnlyActive]);

//   const handleAddEmail = async () => {
//     try {
//       if (!newEmail.emailType || !newEmail.emailId) {
//         toast.error("Please fill in both email type and email address");
//         return;
//       }
//       await organizationEmailApi.createOrganizationEmail({
//         orgId: user.organisationId,
//         emailType: newEmail.emailType,
//         emailId: newEmail.emailId,
//       });
//       toast.success("Email added successfully!");
//       setShowEmailModal(false);
//       setNewEmail({ emailType: "", emailId: "" });
//       fetchOrganizationEmails();
//     } catch (error) {
//       console.error("Error adding email:", error);
//       toast.error("Failed to add email");
//     }
//   };

//   const handleShowTicketInfo = async (ticket) => {
//     setSelectedTicket(ticket);
//     setShowTicketInfoModal(true);
//     try {
//       setLoadingLogs(true);
//       setLoadingTasks(true);
//       const logs = await getTicketLogsByTicketId(ticket.ticketId);
//       setTicketLogs(logs || []);
//       const tasks = await getTasksByTicketId(ticket.ticketId);
//       setTicketTasks(tasks || []);
//       const sla = await getTicketSla(ticket.ticketId);
//       setTicketSla(sla);
//       console.log(sla);
//       const slalogs = await getTicketSlaLogs(ticket.ticketId);
//       setSlaLogs(slalogs);
//     } catch (error) {
//       console.error("❌ Failed to load ticket info data", error);
//       setTicketLogs([]);
//       setTicketTasks([]);
//     } finally {
//       setLoadingLogs(false);
//       setLoadingTasks(false);
//     }
//   };

//   const formatActionType = (type) => type?.replace(/_/g, " ") || "N/A";

//   const formatDateTime = (date, time) => {
//     if (!date) return "N/A";
//     return `${moment(date).format("MMM DD, YYYY")} ${time?.substring(0, 8) || ""}`;
//   };

//   useEffect(() => {
//     if (!tickets.length) return;
//     const fetchAllProjectsAndPartners = async () => {
//       const projectIds = new Set();
//       tickets.forEach((ticket) => {
//         if (ticket.projectAssigned) {
//           ticket.projectAssigned
//             .split(",")
//             .map((id) => id.trim())
//             .forEach((id) => projectIds.add(id));
//         }
//       });
//       for (const projectId of projectIds) {
//         await fetchProjectAndPartners(projectId);
//       }
//     };
//     fetchAllProjectsAndPartners();
//   }, [tickets]);

//   useEffect(() => {
//     if (!selectedTicket || !selectedTicket.projectAssigned) return;
//     const projectIds = selectedTicket.projectAssigned
//       .split(",")
//       .map((id) => id.trim());
//     const map = new Map();
//     projectIds.forEach((pid) => {
//       const assignees = assigneeOptionsByProject[pid] || [];
//       assignees.forEach((opt) => map.set(opt.value, opt));
//     });
//     setTicketAssignees(Array.from(map.values()));
//   }, [selectedTicket, assigneeOptionsByProject]);

//   useEffect(() => {
//     if (!userDetails?.userId || !orgId) return;
//     buildAssignedToOptions();
//   }, [userDetails?.userId, orgId]);

//   useEffect(() => {
//     fetchClosureTypes();
//   }, []);

//   const closureTypeOptions = closureTypes.map((ct) => ({
//     value: ct.codefix,
//     label: ct.description,
//   }));

//   const handleEditTicket = async (ticket) => {
//     resetTicketScopedState();
//     setSelectedTicket(null);
//     if (ticket.projectAssigned) {
//       const projectIds = ticket.projectAssigned
//         .split(",")
//         .map((id) => id.trim());
//       for (const pid of projectIds) {
//         if (!assigneeOptionsByProject[pid]) {
//           await fetchProjectAndPartners(pid);
//         }
//       }
//     }
//     const projectIds = ticket.projectAssigned
//       ? ticket.projectAssigned.split(",").map((id) => id.trim())
//       : [];
//     const map = new Map();
//     projectIds.forEach((pid) => {
//       (assigneeOptionsByProject[pid] || []).forEach((opt) =>
//         map.set(opt.value, opt),
//       );
//     });
//     const finalAssignees = Array.from(map.values());
//     setTicketAssignees(finalAssignees);
//     setUpdateForm({
//       ticketName: ticket.ticketName || "",
//       description: ticket.description || "",
//       status: ticket.status || "Open",
//       subStatus: ticket.subStatus || "",
//       priority: ticket.priority || "Medium",
//       assignedTo: ticket.assignedTo
//         ? ticket.assignedTo.split(",").map((id) => id.trim())
//         : [],
//       createdBy: ticket.createdBy || "",
//       submittedBy: ticket.submittedBy || "",
//       category: ticket.category || "",
//       referenceTo: ticket.referenceTo || "",
//       dueDate: ticket.dueDate
//         ? moment(ticket.dueDate).format("YYYY-MM-DD")
//         : moment(ticket.ticketTime).add(10, "days").format("YYYY-MM-DD"),
//       projectAssigned: ticket.projectAssigned || "",
//       ticketType: ticket.ticketType || "Internal",
//       ticketReason: ticket.ticketReason || "",
//     });
//     setSelectedTicket(ticket);
//     setShowUpdateModal(true);
//   };

//   useEffect(() => {
//     fetchTicketLoggedTypes();
//   }, []);

//   const ticketReasonOptions = ticketLoggedTypes.map((t) => ({
//     value: t.code,
//     label: t.descriptions,
//   }));

//   const fetchTeamDetails = async (teamId) => {
//     try {
//       if (!teamId) return;
//       console.log("🔹 Fetching Team Details for:", teamId);
//       const teamData = await getTeamById(teamId);
//       console.log("✅ Team Details:", teamData);
//       return teamData;
//     } catch (error) {
//       console.error(`❌ Error fetching team ${teamId}`, error);
//     }
//   };

//   const handleProjectCheckboxChange = (projectId, isChecked) => {
//     const currentProjects = updateForm.projectAssigned
//       ? updateForm.projectAssigned.split(",").filter((id) => id !== "")
//       : [];
//     let updatedProjects;
//     if (isChecked) {
//       updatedProjects = [...currentProjects, projectId];
//     } else {
//       updatedProjects = currentProjects.filter((id) => id !== projectId);
//     }
//     setUpdateForm({
//       ...updateForm,
//       projectAssigned: updatedProjects.join(","),
//     });
//   };

//   const isProjectSelected = (projectId) => {
//     if (!updateForm.projectAssigned) return false;
//     const selectedProjects = updateForm.projectAssigned.split(",");
//     return selectedProjects.includes(projectId);
//   };

//   const handleUpdateTicket = async () => {
//     try {
//       if (!selectedTicket) return;
//       if (!updateForm.dueDate || updateForm.dueDate.trim() === "") {
//         toast.error("Due Date is required before updating the ticket.");
//         return;
//       }
//       setLoading(true);
//       const payload = {
//         ticketId: selectedTicket.ticketId,
//         ...updateForm,
//         subStatus: updateForm.subStatus,
//         assignedTo: updateForm.assignedTo.length
//           ? updateForm.assignedTo.join(",")
//           : "",
//         createdBy: updateForm.createdBy ? String(updateForm.createdBy) : "",
//         submittedBy: updateForm.submittedBy
//           ? String(updateForm.submittedBy)
//           : "",
//         editedBy: String(userDetails.userId),
//       };
//       await updateTicket(selectedTicket.ticketId, payload);
//       toast.success("Ticket updated successfully!");
//       setShowUpdateModal(false);
//       setSelectedTicket(null);
//       fetchTickets();
//     } catch (error) {
//       console.error("Error updating ticket:", error);
//       toast.error("Failed to update ticket");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getPriorityBadge = (priority) => {
//     const variants = {
//       critical: "danger",
//       high: "warning",
//       medium: "primary",
//       low: "secondary",
//       normal: "info",
//     };
//     return (
//       <Badge bg={variants[priority?.toLowerCase()] || "secondary"}>
//         {priority}
//       </Badge>
//     );
//   };

//   const getStatusBadge = (status) => {
//     const variants = {
//       open: "success",
//       closed: "secondary",
//       "in progress": "warning",
//       resolved: "info",
//     };
//     return (
//       <Badge bg={variants[status?.toLowerCase()] || "secondary"}>
//         {status}
//       </Badge>
//     );
//   };

//   const resolveTicketReason = (code) => {
//     if (!code) return "N/A";
//     const found = ticketLoggedTypes.find((t) => t.code === code);
//     return found ? found.descriptions : code;
//   };

//   const formatProjectAssigned = (projectAssigned) => {
//     if (!projectAssigned) return "N/A";
//     if (projectAssigned.includes(",")) {
//       return projectAssigned.split(",").map((projectId, index) => {
//         const projectName = getProjectNameById(projectId.trim());
//         return (
//           <Badge
//             key={index}
//             bg="outline-primary"
//             className="me-1 mb-1"
//             style={{ fontSize: "12px", color: "black" }}
//             title={`Project ID: ${projectId.trim()}`}
//           >
//             {projectName}
//           </Badge>
//         );
//       });
//     }
//     const projectName = getProjectNameById(projectAssigned);
//     return (
//       <Badge
//         bg="outline-primary"
//         style={{ fontSize: "12px", color: "black" }}
//         title={`Project ID: ${projectAssigned}`}
//       >
//         {projectName}
//       </Badge>
//     );
//   };

//   const fetchTicketAttachments = async (ticketId) => {
//     try {
//       setLoadingAttachments((prev) => ({ ...prev, [ticketId]: true }));
//       const attachmentData = await attachmentApi.getTicketAttachments(ticketId);
//       if (!attachmentData || !attachmentData.attachments) {
//         setAttachments((prev) => ({ ...prev, [ticketId]: null }));
//         return null;
//       }
//       setAttachments((prev) => ({
//         ...prev,
//         [ticketId]: attachmentData,
//       }));
//       return attachmentData;
//     } catch (error) {
//       console.error("Error fetching attachments:", error);
//       toast.error("Failed to load attachments");
//       return null;
//     } finally {
//       setLoadingAttachments((prev) => ({ ...prev, [ticketId]: false }));
//     }
//   };

//   const handleDownloadAttachment = async (blobUrl, fileName) => {
//     try {
//       const response = await attachmentApi.downloadAttachment(
//         blobUrl,
//         fileName,
//       );
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", fileName);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//       toast.success(`Downloaded: ${fileName}`);
//     } catch (error) {
//       console.error("Error downloading attachment:", error);
//       toast.error("Failed to download attachment");
//     }
//   };

//   const handleViewAttachment = async (blobUrl, fileName) => {
//     try {
//       const response = await attachmentApi.viewAttachment(blobUrl, fileName);
//       const blob = new Blob([response.data], {
//         type: response.headers["content-type"],
//       });
//       const url = window.URL.createObjectURL(blob);
//       window.open(url, "_blank");
//       setTimeout(() => window.URL.revokeObjectURL(url), 1000);
//     } catch (error) {
//       console.error("Error viewing attachment:", error);
//       toast.error("Failed to view attachment");
//     }
//   };

//   const handleShowAttachments = async (ticket) => {
//     setSelectedTicket(ticket);
//     setSelectedTicketAttachments([]);
//     setShowAttachmentsModal(true);
//     if (ticket.attachmentCount > 0 && ticket.attachmentPaths) {
//       const urls = ticket.attachmentPaths.split(";");
//       const names = ticket.attachmentNames
//         ? ticket.attachmentNames.split(";")
//         : [];
//       const attachmentsList = urls.map((url, index) => ({
//         url: url.trim(),
//         name: names[index] ? names[index].trim() : `Attachment ${index + 1}`,
//         index,
//       }));
//       setSelectedTicketAttachments(attachmentsList);
//     } else {
//       try {
//         const attachmentData = await fetchTicketAttachments(ticket.ticketId);
//         if (attachmentData && attachmentData.attachments) {
//           const attachmentsList = attachmentData.attachments.map((att) => ({
//             url: att.azureBlobUrl,
//             name: att.fileName,
//             size: att.fileSize,
//             createdBy: att.createdBy,
//             createdOn: att.createdOn,
//           }));
//           setSelectedTicketAttachments(attachmentsList);
//         } else {
//           setSelectedTicketAttachments([]);
//         }
//       } catch (error) {
//         console.error("Error processing attachments:", error);
//         setSelectedTicketAttachments([]);
//       }
//     }
//   };

//   const formatFileSize = (bytes) => {
//     if (!bytes) return "Unknown size";
//     if (bytes < 1024) return bytes + " B";
//     if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
//     return (bytes / 1048576).toFixed(1) + " MB";
//   };

//   const getFileIcon = (fileName) => {
//     const extension = fileName?.split(".").pop()?.toLowerCase();
//     switch (extension) {
//       case "pdf":
//         return "📄";
//       case "doc":
//       case "docx":
//         return "📝";
//       case "xls":
//       case "xlsx":
//         return "📊";
//       case "jpg":
//       case "jpeg":
//       case "png":
//       case "gif":
//         return "🖼️";
//       case "zip":
//       case "rar":
//         return "📦";
//       case "txt":
//         return "📃";
//       default:
//         return "📎";
//     }
//   };

//   const filteredTickets = tickets
//     .filter((t) => {
//       if (!showOnlyActive) return true;
//       return t.status?.toLowerCase() !== "closed";
//     })
//     .filter((t) => {
//       const q = globalSearch.toLowerCase();
//       return (
//         t.ticketId?.toLowerCase().includes(q) ||
//         t.ticketName?.toLowerCase().includes(q)
//       );
//     })
//     .filter((t) => {
//       if (
//         filters.status.length &&
//         !filters.status.some((s) => s.value === t.status)
//       )
//         return false;
//       if (
//         filters.ticketType.length &&
//         !filters.ticketType.some((x) => x.value === t.ticketType)
//       )
//         return false;
//       if (
//         filters.priority.length &&
//         !filters.priority.some((x) => x.value === t.priority)
//       )
//         return false;
//       if (
//         filters.assignedTo.length &&
//         !filters.assignedTo.some((x) =>
//           t.assignedTo?.split(",").includes(x.value),
//         )
//       )
//         return false;
//       if (
//         filters.submittedBy.length &&
//         !filters.submittedBy.some((x) =>
//           t.submittedBy?.split(",").includes(x.value),
//         )
//       )
//         return false;
//       if (
//         filters.projectAssigned.length &&
//         !filters.projectAssigned.some((x) =>
//           t.projectAssigned?.split(",").includes(x.value),
//         )
//       )
//         return false;
//       if (
//         filters.fromMail &&
//         !t.fromMail?.toLowerCase().includes(filters.fromMail.toLowerCase())
//       )
//         return false;
//       return true;
//     })
//     .sort((a, b) => {
//       if (!sortConfig.key) return 0;
//       const aValue = a[sortConfig.key];
//       const bValue = b[sortConfig.key];
//       if (sortConfig.key === "ticketTime") {
//         return sortConfig.direction === "asc"
//           ? new Date(aValue) - new Date(bValue)
//           : new Date(bValue) - new Date(aValue);
//       }
//       if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
//       if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
//       return 0;
//     });

//   const handleSort = (key) => {
//     setSortConfig((prev) => {
//       if (prev.key === key) {
//         return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
//       } else {
//         return { key, direction: "asc" };
//       }
//     });
//   };

//   const resolveNewValue = (log) => {
//     if (!log?.newValue) return "—";
//     switch (log.actionType) {
//       case "TICKET_REASON_CHANGE":
//         return resolveTicketReason(log.newValue);
//       case "ASSIGNMENT":
//         return resolveAssigneeName(log.newValue);
//       default:
//         return log.newValue;
//     }
//   };

//   const resolveClosureType = (code) => {
//     if (!code) return "—";
//     const found = closureTypes.find((ct) => ct.codefix === code);
//     return found ? found.description : code;
//   };

//   useEffect(() => {
//     if (!tickets.length) return;
//     const cpIds = new Set();
//     tickets.forEach((t) => {
//       ["assignedTo", "submittedBy", "createdBy"].forEach((field) => {
//         if (t[field]) {
//           t[field]
//             .split(",")
//             .map((id) => id.trim())
//             .filter((id) => id.startsWith("CVCP"))
//             .forEach((id) => cpIds.add(id));
//         }
//       });
//     });
//     cpIds.forEach((id) => fetchCusVenCpIfNeeded(id));
//   }, [tickets]);

//   const totalPages = Math.ceil(filteredTickets.length / ITEMS_PER_PAGE);

//   const paginatedTickets = filteredTickets.slice(
//     (currentPage - 1) * ITEMS_PER_PAGE,
//     currentPage * ITEMS_PER_PAGE,
//   );

//   const combinedUserOptions = [...assignedToOptions, ...cusVenOptions];

//   const getRemainingTime = (dueTime) => {
//     if (!dueTime) return "N/A";
//     const now = moment.utc();
//     const due = moment.utc(dueTime);
//     console.log("NOW UTC:", now.format());
//     console.log("DUE UTC:", due.format());
//     const diff = due.diff(now);
//     console.log("DIFF MIN:", diff / 60000);
//     if (diff <= 0) return "BREACHED";
//     const duration = moment.duration(diff);
//     const hours = Math.floor(duration.asHours());
//     const minutes = duration.minutes();
//     return `${hours}h ${minutes}m`;
//   };

//   return (
//     <div className="tickets-container">
//       <Container fluid className="tickets-container__inner">
//         <Card className="tickets-card">
//           <Card.Header className="tickets-card__header">
//             <div className="tickets-header">
//               <div className="tickets-header__left">
//                 <h5 className="tickets-header__title">Tickets</h5>
//                 <Badge bg="primary" className="tickets-count">
//                   {filteredTickets.length}
//                 </Badge>
//               </div>
//               <div className="tickets-header__center">
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Ticket ID, Name, Description..."
//                   value={globalSearch}
//                   onChange={(e) => setGlobalSearch(e.target.value)}
//                   className="tickets-search"
//                 />
//                 <Button
//                   variant="outline-primary"
//                   size="sm"
//                   onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
//                   className="tickets-filter-toggle"
//                 >
//                   Advanced Filters {showAdvancedFilters ? "▲" : "▼"}
//                 </Button>
//                 <Form.Check
//                   type="checkbox"
//                   id="activeTicketsOnly"
//                   label="Active"
//                   checked={showOnlyActive}
//                   onChange={(e) => setShowOnlyActive(e.target.checked)}
//                   className="tickets-active-checkbox"
//                 />
//                 <Button
//                   variant="outline-danger"
//                   size="sm"
//                   onClick={handleResetFilters}
//                   className="tickets-reset-btn"
//                 >
//                   Reset
//                 </Button>
//               </div>
//               <div className="tickets-header__right">
//                 <Button
//                   variant="primary"
//                   size="sm"
//                   onClick={() => setShowCreateModal(true)}
//                   className="tickets-create-btn"
//                 >
//                   + Create Ticket
//                 </Button>
//                 <Button
//                   variant="success"
//                   size="sm"
//                   onClick={handleExportToExcel}
//                   className="tickets-export-btn"
//                 >
//                   ⬇ Export Excel
//                 </Button>
//                 <Button
//                   variant="outline-secondary"
//                   size="sm"
//                   onClick={fetchTickets}
//                   disabled={loading}
//                   className="tickets-refresh-btn"
//                 >
//                   Refresh
//                 </Button>
//               </div>
//             </div>
//           </Card.Header>

//           {showAdvancedFilters && (
//             <Card.Body className="tickets-filters-panel">
//               <Row className="g-3">
//                 <Col md={3}>
//                   <Select
//                     isMulti
//                     options={statusOptions}
//                     placeholder="Status"
//                     value={filters.status}
//                     onChange={(v) =>
//                       setFilters({ ...filters, status: v || [] })
//                     }
//                   />
//                 </Col>
//                 <Col md={3}>
//                   <Select
//                     isMulti
//                     placeholder="Ticket Type"
//                     options={[
//                       { value: "Internal", label: "Internal" },
//                       { value: "Client", label: "Client" },
//                       { value: "Support", label: "Support" },
//                       { value: "Technical", label: "Technical" },
//                     ]}
//                     value={filters.ticketType}
//                     onChange={(v) =>
//                       setFilters({ ...filters, ticketType: v || [] })
//                     }
//                   />
//                 </Col>
//                 <Col md={3}>
//                   <Select
//                     isMulti
//                     placeholder="Priority"
//                     options={[
//                       { value: "Low", label: "Low" },
//                       { value: "Normal", label: "Normal" },
//                       { value: "Medium", label: "Medium" },
//                       { value: "High", label: "High" },
//                       { value: "Critical", label: "Critical" },
//                     ]}
//                     value={filters.priority}
//                     onChange={(v) =>
//                       setFilters({ ...filters, priority: v || [] })
//                     }
//                   />
//                 </Col>
//                 <Col md={3}>
//                   <Form.Control
//                     placeholder="From Mail"
//                     value={filters.fromMail}
//                     onChange={(e) =>
//                       setFilters({ ...filters, fromMail: e.target.value })
//                     }
//                   />
//                 </Col>
//                 <Col md={4}>
//                   <Select
//                     isMulti
//                     placeholder="Assigned To"
//                     options={combinedUserOptions}
//                     value={filters.assignedTo}
//                     onChange={(v) =>
//                       setFilters({ ...filters, assignedTo: v || [] })
//                     }
//                   />
//                 </Col>
//                 <Col md={4}>
//                   <Select
//                     isMulti
//                     placeholder="Submitted By"
//                     options={combinedUserOptions}
//                     value={filters.submittedBy}
//                     onChange={(v) =>
//                       setFilters({ ...filters, submittedBy: v || [] })
//                     }
//                   />
//                 </Col>
//                 <Col md={4}>
//                   <Select
//                     isMulti
//                     placeholder="Project Assigned"
//                     options={projectOptions}
//                     value={filters.projectAssigned}
//                     onChange={(v) =>
//                       setFilters({ ...filters, projectAssigned: v || [] })
//                     }
//                   />
//                 </Col>
//               </Row>
//             </Card.Body>
//           )}

//           <Card.Body className="tickets-card__body">
//             {loading ? (
//               <div className="text-center">
//                 <Spinner animation="border" role="status">
//                   <span className="visually-hidden">Loading...</span>
//                 </Spinner>
//               </div>
//             ) : filteredTickets.length > 0 ? (
//               <div className="tickets-table-wrapper">
//                 <div className="tickets-table-scroll">
//                   <Table bordered hover className="tickets-table">
//                     <thead className="tickets-table__head">
//                       <tr>
//                         <th>#</th>
//                         <th
//                           className="tickets-table__sortable"
//                           onClick={() => handleSort("ticketId")}
//                         >
//                           Ticket ID{" "}
//                           {sortConfig.key === "ticketId" && (
//                             <span>
//                               {sortConfig.direction === "asc" ? "▲" : "▼"}
//                             </span>
//                           )}
//                         </th>
//                         <th>Ticket Name</th>
//                         <th
//                           className="tickets-table__sortable"
//                           onClick={() => handleSort("ticketTime")}
//                         >
//                           Ticket Time{" "}
//                           {sortConfig.key === "ticketTime" && (
//                             <span>
//                               {sortConfig.direction === "asc" ? "▲" : "▼"}
//                             </span>
//                           )}
//                         </th>
//                         <th>Due Date</th>
//                         <th>Status</th>
//                         <th>Sub Status</th>
//                         <th>Ticket Type</th>
//                         <th>Priority</th>
//                         <th>Reference To</th>
//                         <th>Submitted By</th>
//                         <th>Assigned To</th>
//                         <th>Ticket Reason:</th>
//                         <th>From Mail</th>
//                         <th>Category</th>
//                         <th>Project Assigned</th>
//                         <th>SLA Status</th>
//                         <th className="tickets-table__sticky-attachment">
//                           Attachments
//                         </th>
//                         <th className="tickets-table__sticky-actions">
//                           Actions
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {paginatedTickets.map((ticket, index) => (
//                         <tr key={index}>
//                           <td>
//                             {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
//                           </td>
//                           <td>
//                             <Badge bg="dark">{ticket.ticketId || "N/A"}</Badge>
//                           </td>
//                           <td>
//                             <Link
//                               className="tickets-table__link"
//                               to={`/ticketinfo/${ticket.ticketId}`}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               title="Open ticket details"
//                             >
//                               {ticket.ticketName || "N/A"}
//                             </Link>
//                           </td>
//                           <td>
//                             {ticket.ticketTime
//                               ? moment
//                                   .utc(ticket.ticketTime)
//                                   .add(5, "hours")
//                                   .add(30, "minutes")
//                                   .format("MMM DD, YYYY HH:mm")
//                               : "N/A"}
//                           </td>
//                           <td>
//                             {ticket.dueDate
//                               ? moment(ticket.dueDate).format("MMM DD, YYYY")
//                               : "N/A"}
//                           </td>
//                           <td>{getStatusBadge(ticket.status)}</td>
//                           <td>
//                             <Badge bg="secondary">
//                               {ticket.subStatus || "N/A"}
//                             </Badge>
//                           </td>
//                           <td>
//                             <Badge bg="outline-info" style={{ color: "black" }}>
//                               {ticket.ticketType || "No Type"}
//                             </Badge>
//                           </td>
//                           <td>{getPriorityBadge(ticket.priority)}</td>
//                           <td>{ticket.referenceTo || "N/A"}</td>
//                           <td>{resolveAssigneeName(ticket.submittedBy)}</td>
//                           <td>{resolveAssigneeName(ticket.assignedTo)}</td>
//                           <td>{resolveTicketReason(ticket.ticketReason)}</td>
//                           <td>
//                             {ticket.fromMails && ticket.fromMails.length > 0
//                               ? ticket.fromMails.map((email, i) => (
//                                   <Badge
//                                     bg="light"
//                                     text="dark"
//                                     key={i}
//                                     className="me-1"
//                                   >
//                                     {email}
//                                   </Badge>
//                                 ))
//                               : ticket.fromMail || "N/A"}
//                           </td>
//                           <td>
//                             <Badge bg="info">{ticket.category || "N/A"}</Badge>
//                           </td>
//                           <td>
//                             {formatProjectAssigned(ticket.projectAssigned)}
//                           </td>
//                           <td>
//                             {ticket.slaStatus === "Breached" ? (
//                               <Badge bg="danger">Breached</Badge>
//                             ) : ticket.slaStatus === "Running" ? (
//                               <Badge bg="success">Running</Badge>
//                             ) : (
//                               <Badge bg="secondary">Completed</Badge>
//                             )}
//                             <div style={{ fontSize: "12px" }}>
//                               {getRemainingTime(ticket.responseDueTime) ||
//                                 "N/A"}
//                             </div>
//                           </td>
//                           <td className="tickets-table__sticky-attachment">
//                             <Button
//                               variant="outline-primary"
//                               size="sm"
//                               onClick={() => handleShowAttachments(ticket)}
//                               disabled={loadingAttachments[ticket.ticketId]}
//                               className="tickets-table__attach-btn"
//                             >
//                               {loadingAttachments[ticket.ticketId] ? (
//                                 <Spinner animation="border" size="sm" />
//                               ) : (
//                                 "View"
//                               )}
//                             </Button>
//                           </td>
//                           <td className="tickets-table__sticky-actions">
//                             <Button
//                               variant="outline-primary"
//                               size="sm"
//                               onClick={() => handleEditTicket(ticket)}
//                               className="tickets-table__edit-btn"
//                             >
//                               Edit
//                             </Button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </div>
//                 {totalPages > 1 && (
//                   <div className="tickets-pagination">
//                     <Button
//                       variant="outline-secondary"
//                       size="sm"
//                       disabled={currentPage === 1}
//                       onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                       className="tickets-pagination__prev"
//                     >
//                       ◀ Prev
//                     </Button>
//                     <div className="tickets-pagination__info">
//                       Page <strong>{currentPage}</strong> of{" "}
//                       <strong>{totalPages}</strong>
//                     </div>
//                     <Button
//                       variant="outline-secondary"
//                       size="sm"
//                       disabled={currentPage === totalPages}
//                       onClick={() =>
//                         setCurrentPage((p) => Math.min(p + 1, totalPages))
//                       }
//                       className="tickets-pagination__next"
//                     >
//                       Next ▶
//                     </Button>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <Alert variant="info" className="text-center">
//                 No tickets found.
//               </Alert>
//             )}
//           </Card.Body>
//         </Card>

//         {/* Modals remain unchanged */}
//         <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)}>
//           <Modal.Header closeButton>
//             <Modal.Title>Add Organization Email</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form>
//               <Form.Group className="mb-3">
//                 <Form.Label>Email Type</Form.Label>
//                 <Form.Select
//                   value={newEmail.emailType}
//                   onChange={(e) =>
//                     setNewEmail({ ...newEmail, emailType: e.target.value })
//                   }
//                 >
//                   <option value="">Select email type...</option>
//                   <option value="support">Support</option>
//                   <option value="sales">Sales</option>
//                   <option value="general">General</option>
//                   <option value="billing">Billing</option>
//                   <option value="technical">Technical</option>
//                 </Form.Select>
//               </Form.Group>
//               <Form.Group className="mb-3">
//                 <Form.Label>Email Address</Form.Label>
//                 <Form.Control
//                   type="email"
//                   placeholder="Enter email address"
//                   value={newEmail.emailId}
//                   onChange={(e) =>
//                     setNewEmail({ ...newEmail, emailId: e.target.value })
//                   }
//                 />
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowEmailModal(false)}
//             >
//               Cancel
//             </Button>
//             <Button variant="primary" onClick={handleAddEmail}>
//               Add Email
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         <TicketEditModal
//           show={showUpdateModal}
//           onClose={() => setShowUpdateModal(false)}
//           ticket={selectedTicket}
//           orgId={orgId}
//           userDetails={userDetails}
//           projectOptions={projectOptions}
//           ticketAssignees={ticketAssignees}
//           assigneeOptionsByProject={assigneeOptionsByProject}
//           fetchProjectAndPartners={fetchProjectAndPartners}
//           refreshTickets={fetchTickets}
//         />

//         <TicketCreateModal
//           show={showCreateModal}
//           onClose={() => setShowCreateModal(false)}
//           orgId={orgId}
//           userDetails={userDetails}
//           projectOptions={projectOptions}
//           assigneeOptionsByProject={assigneeOptionsByProject}
//           refreshTickets={fetchTickets}
//         />

//         <Modal
//           show={showAttachmentsModal}
//           onHide={() => setShowAttachmentsModal(false)}
//           size="lg"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               Attachments for Ticket: {selectedTicket?.ticketId || "Unknown"}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {selectedTicketAttachments &&
//             selectedTicketAttachments.length > 0 ? (
//               <div>
//                 <p className="text-muted mb-3">
//                   {selectedTicketAttachments.length} attachment(s) found
//                   {attachments[selectedTicket?.ticketId]?.TotalAttachmentSize >
//                     0 &&
//                     ` • Total size: ${formatFileSize(
//                       attachments[selectedTicket?.ticketId]
//                         ?.totalAttachmentSize,
//                     )}`}
//                 </p>
//                 <div className="attachments-list">
//                   {selectedTicketAttachments.map((attachment, index) => (
//                     <Card key={index} className="mb-2">
//                       <Card.Body className="py-2">
//                         <div className="d-flex justify-content-between align-items-center">
//                           <div className="d-flex align-items-center">
//                             <span
//                               className="me-2"
//                               style={{ fontSize: "1.2em" }}
//                             >
//                               {getFileIcon(attachment.name)}
//                             </span>
//                             <div>
//                               <div className="fw-bold">{attachment.name}</div>
//                               <small className="text-muted">
//                                 {formatFileSize(attachment.size)} • Uploaded by{" "}
//                                 {attachment.createdBy}
//                               </small>
//                             </div>
//                           </div>
//                           <div>
//                             <Button
//                               variant="outline-primary"
//                               size="sm"
//                               className="me-1"
//                               onClick={() =>
//                                 handleViewAttachment(
//                                   attachment.url,
//                                   attachment.name,
//                                 )
//                               }
//                               title="View in browser"
//                               disabled={!attachment.url}
//                             >
//                               👁️ View
//                             </Button>
//                             <Button
//                               variant="outline-success"
//                               size="sm"
//                               onClick={() =>
//                                 handleDownloadAttachment(
//                                   attachment.url,
//                                   attachment.name,
//                                 )
//                               }
//                               title="Download file"
//                               disabled={!attachment.url}
//                             >
//                               ⬇️ Download
//                             </Button>
//                           </div>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <div className="text-center py-4">
//                 <div className="text-muted">
//                   No attachments found for this ticket
//                 </div>
//                 <small className="text-muted">
//                   This ticket either has no attachments or the attachment data
//                   is not available.
//                 </small>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowAttachmentsModal(false)}
//             >
//               Close
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         <Modal
//           show={showClosureModal}
//           onHide={() => setShowClosureModal(false)}
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>Close Ticket</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form.Group className="mb-3">
//               <Form.Label>Closure Type</Form.Label>
//               <Select
//                 options={closureTypeOptions}
//                 isLoading={loadingClosureTypes}
//                 value={closureTypeOptions.find(
//                   (opt) => opt.value === closureForm.closureTypeCode,
//                 )}
//                 onChange={(opt) =>
//                   setClosureForm({
//                     ...closureForm,
//                     closureTypeCode: opt?.value || "",
//                   })
//                 }
//                 placeholder="Select closure type..."
//               />
//             </Form.Group>
//             <hr />
//             <h6 className="mb-2">Work Effort Details</h6>
//             {closureForm.efforts.map((effort, index) => (
//               <Row key={index} className="align-items-end mb-2">
//                 <Col md={5}>
//                   <Form.Label>Worked By</Form.Label>
//                   <Select
//                     options={ticketAssignees}
//                     value={ticketAssignees.find(
//                       (o) => o.value === effort.workedBy,
//                     )}
//                     onChange={(opt) =>
//                       updateEffortRow(index, "workedBy", opt?.value)
//                     }
//                     placeholder="Select user..."
//                     isClearable
//                   />
//                 </Col>
//                 <Col md={3}>
//                   <Form.Label>Effort</Form.Label>
//                   <Form.Control
//                     type="number"
//                     step="0.25"
//                     value={effort.effortValue}
//                     onChange={(e) =>
//                       updateEffortRow(index, "effortValue", e.target.value)
//                     }
//                   />
//                 </Col>
//                 <Col md={2}>
//                   <Form.Label>Unit</Form.Label>
//                   <Form.Select
//                     value={effort.effortUnit}
//                     onChange={(e) =>
//                       updateEffortRow(index, "effortUnit", e.target.value)
//                     }
//                   >
//                     <option value="HOURS">Hours</option>
//                     <option value="DAYS">Days</option>
//                   </Form.Select>
//                 </Col>
//                 <Col md={2}>
//                   <Button
//                     variant="outline-danger"
//                     onClick={() => removeEffortRow(index)}
//                     disabled={closureForm.efforts.length === 1}
//                   >
//                     ✕
//                   </Button>
//                 </Col>
//               </Row>
//             ))}
//             <Button variant="outline-primary" size="sm" onClick={addEffortRow}>
//               + Add Member Effort
//             </Button>
//             <hr />
//             <Form.Group className="mb-3 mt-3">
//               <Form.Label>Closure Remarks</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 value={closureForm.closureRemarks}
//                 onChange={(e) =>
//                   setClosureForm({
//                     ...closureForm,
//                     closureRemarks: e.target.value,
//                   })
//                 }
//               />
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowClosureModal(false)}
//             >
//               Cancel
//             </Button>
//             <Button variant="danger" onClick={handleConfirmClosure}>
//               Close Ticket
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         <Modal
//           show={showWorkLogModal}
//           onHide={() => setShowWorkLogModal(false)}
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>Add Work Log</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form.Group className="mb-3">
//               <Form.Label>Worked By</Form.Label>
//               <Select
//                 options={ticketAssignees}
//                 value={ticketAssignees.find(
//                   (o) => o.value === workLogForm.workedBy,
//                 )}
//                 onChange={(opt) =>
//                   setWorkLogForm({
//                     ...workLogForm,
//                     workedBy: opt?.value || "",
//                   })
//                 }
//                 placeholder="Select user..."
//               />
//             </Form.Group>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Effort</Form.Label>
//                   <Form.Control
//                     type="number"
//                     step="0.25"
//                     value={workLogForm.effortValue}
//                     onChange={(e) =>
//                       setWorkLogForm({
//                         ...workLogForm,
//                         effortValue: e.target.value,
//                       })
//                     }
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Unit</Form.Label>
//                   <Form.Select
//                     value={workLogForm.effortUnit}
//                     onChange={(e) =>
//                       setWorkLogForm({
//                         ...workLogForm,
//                         effortUnit: e.target.value,
//                       })
//                     }
//                   >
//                     <option value="HOURS">Hours</option>
//                     <option value="DAYS">Days</option>
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//             </Row>
//             <Form.Group className="mb-3">
//               <Form.Label>Remarks</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 value={workLogForm.remarks}
//                 onChange={(e) =>
//                   setWorkLogForm({
//                     ...workLogForm,
//                     remarks: e.target.value,
//                   })
//                 }
//               />
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowWorkLogModal(false)}
//             >
//               Cancel
//             </Button>
//             <Button variant="primary" onClick={handleAddWorkLog}>
//               Save Work Log
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </Container>
//     </div>
//   );
// };

// export default ViewTickets;
